import { Component, OnInit, ViewChild, ViewEncapsulation, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { catchError, debounceTime, distinctUntilChanged, filter, first, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { concat, from, Observable, of, Subject, throwError } from 'rxjs';

import { CoreConfigService } from '../../../@core/services/config.service';
import Stepper from 'bs-stepper';
import { ActivatedRoute, Router, Event, NavigationError } from '@angular/router';
import Swal from 'sweetalert2';
import { FileUploader } from 'ng2-file-upload';
import { ToastrService } from 'ngx-toastr';
import { ParentParameters, statusCode,applicationFrom } from '../../auth/models/commonEnum';
import { AuthenticationService, CommonService } from '../../auth/service';
import { ApplyonlineService } from "../apply-online/applyonline.service";
import { EuttcProposalService } from './euttc-proposal.service';
import { NgbCalendar, NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as converter from 'number-to-words';
import * as moment from "moment";
import { PDFDocument } from 'pdf-lib';
import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexPlotOptions,
  ApexXAxis,
  ApexFill,
  ApexDataLabels,
  ApexYAxis,
  ApexGrid} from "ng-apexcharts";
import { CurrencyPipe } from '@angular/common';
import { environment } from 'environments/environment';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  fill: ApexFill;
  dataLabels: ApexDataLabels;
  grid: ApexGrid;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  plotOptions: ApexPlotOptions;
};


const URL = 'https://your-url.com';
@Component({
  selector: 'app-euttc-proposal',
  templateUrl: './euttc-proposal.component.html',
  styleUrls: ['./euttc-proposal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EuttcProposalComponent implements OnInit {
  hideButton: boolean = false;
  private targetDate = new Date('2025-09-05T23:59:00');
  
  @ViewChild("chart") chart: ChartComponent;
  
  public chartOptions: Partial<ChartOptions>;
  public coreConfig: any;
  public format1: FormGroup;
  public format2: FormGroup;
  public format3: FormGroup;
  public format4: FormGroup;
  public format5: FormGroup;

  // For Chart

  public contentHeader: object;

  public apexBarChart: Partial<ChartOptions>;

  public isMenuToggled = false;

  
  documentURL: any;
  displayField = false;
  displayOtherField = false;
  displayLeadPartnerField = false;
  displayCoPrincipalField = false;
  contactDetailsForm : FormGroup;
  totalCostForm: FormGroup;
  projectPlanForm: FormGroup;
  equipmentForm: FormGroup;
  manpowerForm: FormGroup;
  consumablesForm: FormGroup;
  travelForm: FormGroup;
  proposedCostForm: FormGroup;
  myFiles: any = [];
  tempFiles: any = [];
  myFilesStep3: any = [];
  tempFilesStep3: any = [];
  dynamicColumnCount = 0;
  public isDisabled = false;
  public uploader: FileUploader = new FileUploader({
    url: URL,
    isHTML5: true,
  });
  public loading = false;
  public returnUrl: string;
  public error = '';

  public submitted = false;
  private horizontalWizardStepper: Stepper;

  public budgetType = [];
  public unitsType = [];
  public projectType = [];
  public categoryOfInstitution = [];
  public AreaOfResearch = [];
  public Gender = [];
  public principalImplementing = [];
  public proposedCostItemList = [];
  public hasDuplicateCostType: boolean | false;
  principalInvestigatorListArray: Observable<any>;
  dataLoading = false;
  userInput = new Subject<string>();
  selectedMovie: any;
  minLengthTerm = 3;
  currentUser: any;
  
  maxDate = this.calendar.getToday();
  minDate = this.calendar.getPrev(this.calendar.getToday(), 'y', 10);
  public maximumDate : any;
  endminDate = (this.minDate != undefined && this.minDate != null) ? this.minDate : this.calendar.getToday();
  fileName: any;
  files: any;
  stateArray: any[];
  districtArray: any[];
  cityArray: any[];
  public monthAddedDate: any;
  public finalmaxdate: any;
  public nextMinDate: any;
  public applicationID: any;
  public tempTotalCostArray: any;
  public subjectAreaType = [];
  public subjectAreaId : [];
  public getSubjectAreaId : [];
  public noOfyear: any;
  public noOfYeararray = [];
  public noOfYearisReset: boolean | false;
  file:any;
  copifile: any;
  subletterfile: any;
  annexureFirstFile: any;
  annexureSecondFile: any;
  annexureThirdFile: any;
  annexureFourthFile: any;
  annexureSecondDFile: any;
  annexureSecondEFile: any;
  // coPrincipalDetailss = [ 
  //   { id: 1, name: "No" }, 
  //   { id: 2, name: "Yes" }, 
  //   ];
  // applicantCategory = [ 
  //   { id: 1, name: "Academic Institutions" }, 
  //   { id: 2, name: "R&D Institutions" }, 
  //   { id: 3, name: "Government Institutions" }, 
  //   { id: 4, name: "PSUs" }, 
  //   { id: 5, name: "Private Research Institutions" },
  //   { id: 6, name: "Industries in partnership with above mentioned entities" },
  //   { id: 7, name: "Consortium/ JV (mention lead partner with composition)" },  
  //   ];

  // areaOfResearch = [ 
  //   { id: 1, name: "Hydrogen Production" }, 
  //   { id: 2, name: "Hydrogen Storage" }, 
  //   { id: 3, name: "Transportation" }, 
  //   { id: 4, name: "Applications" }, 
  //   { id: 5, name: "Safety Cross-cutting Analysis and Integration" },
  //   { id: 6, name: "Others" },  
  //   ]; 

    // gender = [ 
    // { id: 1, name: "Male" }, 
    // { id: 2, name: "Female" }, 
    // { id: 3, name: "Others" },  
    // ];
    
    // casteCategorylist = [ 
    // { id: 1, name: "General" }, 
    // { id: 2, name: "ST" }, 
    // { id: 3, name: "SC" },
    // { id: 4, name: "OBC" },
    // { id: 5, name: "Others" },  
    // ];

    //selected = '';
    selected: any;
  selectedOption: any;
  maxSizeInMB = 10.1; // Maximum file size in MB
  /**
   * Horizontal Wizard Stepper Next
   *
   * @param data
   */
  horizontalWizardStepperNext(data,stepNumber=0) {
    this.submitted = true;
    //this.clearValidation();
    //this.clearOtherAreaofResearchValidation();
    //this.clearLeadPartnerValidation();
    //this.clearCoPrincipalValidation();
    // const projectPlanArray = <FormArray>this.projectPlanForm.controls['projectPlanArray'];
    // if(stepNumber == 2 && projectPlanArray.status !== "VALID"){
    // 	data.status = "INVALID";
    // 	this.toastr.info('please fillup the current row details.', 'Info!', {
    // 		positionClass: 'toast-bottom-right',
    // 		toastClass: 'toast ngx-toastr',
    // 		closeButton: true
    // 	});
    // }
    if (data.status === "VALID") {
      this.submitted = false;
      this.horizontalWizardStepper.next();
    }
  }
  /**
   * Horizontal Wizard Stepper Previous
   */
  // horizontalWizardStepperPrevious() {
  //   //this.format1.controls.Duration.setValue("");
  //   this.setNoofYears1(60,true);
  //   this.contactDetailsForm = this._formBuilder.group({
  //     contactDetailsArray: this._formBuilder.array([])
  //   });

  //   this.totalCostForm = this._formBuilder.group({
  //     costArray: this._formBuilder.array([])
  //   });

  //   this.projectPlanForm = this._formBuilder.group({
  //     projectPlanArray: this._formBuilder.array([])
  //   });

  //   this.proposedCostForm = this._formBuilder.group({
  //     proposedCostArray: this._formBuilder.array([])
  //   });

  //   this.equipmentForm = this._formBuilder.group({
  //     equipmentArray: this._formBuilder.array([])
  //   });

  //   this.manpowerForm = this._formBuilder.group({
  //     manpowerArray: this._formBuilder.array([])
  //   });

  //   this.consumablesForm = this._formBuilder.group({
  //     consumablesArray: this._formBuilder.array([])
  //   });

  //   this.travelForm = this._formBuilder.group({
  //     travelArray: this._formBuilder.array([])
  //   });
    
  //   if(this.applicationID != undefined){
  //     this.getCoeApplicationDetails(this.applicationID);
  //   }

  //   this.horizontalWizardStepper.previous();
  // }

  // clearValidation() {
  //   if (!this.displayField) {
  //     this.format1.get('DarpanPortlRegisterID').clearValidators();
  //     this.format1.controls.DarpanPortlRegisterID.setValue("");
  //   }
  // }

  // clearOtherAreaofResearchValidation() {
  //   if (!this.displayOtherField) {
  //     this.format1.get('OtherAreaofResearch').clearValidators();
  //     this.format1.controls.OtherAreaofResearch.setValue("");
  //   }
  // }

  // clearLeadPartnerValidation() {
  //   if (!this.displayLeadPartnerField) {
  //     this.format1.get('LeadPartner').clearValidators();
  //     this.format1.controls.LeadPartner.setValue("");
  //   }else{
  //     this.format1.get('LeadPartner').setValidators([Validators.required]);
  //     this.format1.get('LeadPartner').updateValueAndValidity();

  //   }
  // }

  // clearCoPrincipalValidation() {
  //   if (!this.displayCoPrincipalField) {
  //     this.format1.get('CoPiName').clearValidators();
  //     this.format1.controls.CoPiName.setValue("");
  //     this.format1.get('CoPiTelephone').clearValidators();
  //     this.format1.controls.CoPiTelephone.setValue("");
  //     this.format1.get('CoPiEmail').clearValidators();
  //     this.format1.controls.CoPiEmail.setValue("");
  //     this.format1.get('CoPrincipaIinvestigatorCvFileName').clearValidators();
  //     this.format1.controls.CoPrincipaIinvestigatorCvFileName.setValue("");
  //   }else{
  //     this.format1.get('CoPiName').setValidators([Validators.required]);
  //     this.format1.get('CoPiName').updateValueAndValidity();
  //     this.format1.get('CoPiTelephone').setValidators([Validators.required,Validators.pattern('^[6-9]\\d{9}$')]);
  //     this.format1.get('CoPiTelephone').updateValueAndValidity();
  //     this.format1.get('CoPiEmail').setValidators([Validators.required,Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]);
  //     this.format1.get('CoPiEmail').updateValueAndValidity();
  //     //this.format1.get('CoPrincipaIinvestigatorCvFileName').setValidators([Validators.required]);
  //     //this.format1.get('CoPrincipaIinvestigatorCvFileName').updateValueAndValidity();
  //   }
  // }

  // clearprincipaIinvestigatorCvFileValidation() {
  //   if (this.applicationID != undefined) {
  //     this.format1.get('principaIinvestigatorCvFileName').clearValidators();
  //     this.format1.controls.principaIinvestigatorCvFileName.setValue("");
  //     this.format1.get('CoPrincipaIinvestigatorCvFileName').clearValidators();
  //     this.format1.controls.CoPrincipaIinvestigatorCvFileName.setValue("");
  //     this.format1.get('SubstantiatedLettersFileName').clearValidators();
  //     this.format1.controls.SubstantiatedLettersFileName.setValue("");
  //   }
  // }



  // clearAnnexureFileValidation() {
  //   if (this.applicationID != undefined) {
  //     this.format1.get('DetailofAnnexureFirstFile').clearValidators();
  //     this.format1.controls.DetailofAnnexureFirstFile.setValue("");
  //           this.format1.get('DetailofAnnexureSecondFile').clearValidators();
  //         this.format1.controls.DetailofAnnexureSecondFile.setValue("");
  //     this.format1.get('DetailofAnnexureThirdFile').clearValidators();
  //     this.format1.controls.DetailofAnnexureThirdFile.setValue("");
  //           this.format1.get('DetailofAnnexureFourthFile').clearValidators();
  //     this.format1.controls.DetailofAnnexureFourthFile.setValue("");
  //           this.format1.get('DetailofAnnexureSecondDFile').clearValidators();
  //     this.format1.controls.DetailofAnnexureSecondDFile.setValue("");
  //           this.format1.get('DetailofAnnexureSecondEFile').clearValidators();
  //     this.format1.controls.DetailofAnnexureSecondEFile.setValue("");


  //   }
  // }

  // Private
  private _unsubscribeAll: Subject<any>;

  //public contentHeader;
  constructor(private _router: Router,
    private _coreConfigService: CoreConfigService,
    private _formBuilder: FormBuilder,
    private toastr: ToastrService,
    private _applyOnlineEuttcService: EuttcProposalService,
    private _commonService: CommonService,
    private calendar: NgbCalendar,
    private authService: AuthenticationService,
    private route: ActivatedRoute, private readonly changeDetectorRef: ChangeDetectorRef,
    
  ) {

    this._unsubscribeAll = new Subject();
    this.currentUser = this.authService.currentUserValue;
    this.format1 = this._formBuilder.group({
      ProjectTitle: ['', [Validators.required,Validators.maxLength(225)]],
      Summary: ['', [Validators.required,Validators.maxLength(5000)]],
      DetailofAnnexureFirstFile: [null,[Validators.required]],
      // DetailofAnnexureSecondAFile: [null,[Validators.required]],
      // DetailofAnnexureThirdFile: [null,[Validators.required]],
      // DetailofAnnexureFourthFile: [null,[Validators.required]],
      // DetailofAnnexureSecondDFile: [null,[Validators.required]],
      // DetailofAnnexureSecondEFile: [null,[Validators.required]], 
    });

    this.format2 = this._formBuilder.group({
      DetailofAnnexureFirstFile: [null,[Validators.required]],
      DetailofAnnexureSecondFile: [null,[Validators.required]],
      DetailofAnnexureThirdFile: [null,[Validators.required]],
      DetailofAnnexureFourthFile: [null,[Validators.required]],
      DetailofAnnexureSecondDFile: [null,[Validators.required]],
      DetailofAnnexureSecondEFile: [null,[Validators.required]],
      allTotalCost: [0.00]
    });

    this.format3 = this._formBuilder.group({
      total_Quantity_Year1: [0],
      total_Quantity_Year2: [0],
      total_Quantity_Year3: [0],
      total_Quantity: [0],
      total_Year1: [0.00],
      total_Year2: [0.00],
      total_Year3: [0.00],
      // total: [0],
      // total_Fe_Year1: [0],
      // total_Fe_Year2: [0],
      // total_Fe_Year3: [0],
      // total_Fe: [0],
    });

    this.format4 = this._formBuilder.group({

    });

    this.format5 = this._formBuilder.group({

    });

  }
  // setNoofYears1(value: any, resetTable: any){
  //   //alert(value);
  //   //const control = <FormArray>this.proposedCostForm.controls['proposedCostArray'];
  //   //control.clear();
  //   this.format2.controls.allTotalCost.setValue(0);

  //   //const manPowerControl = <FormArray>this.manpowerForm.controls['manpowerArray'];
  //   //manPowerControl.clear();

  //   //const costofConsumableControl = <FormArray>this.consumablesForm.controls['consumablesArray'];
  //   //costofConsumableControl.clear();

  //   //const travelRowArray = <FormArray>this.travelForm.controls['travelArray'];
  //   //travelRowArray.clear();

  //   this.noOfyear = (value / 12);
  //   this.noOfYeararray = [];
  //   for(var i= 0; i< this.noOfyear; i++){
  //     let yearString =  converter.toWordsOrdinal((i + 1)) + " " + "Year";
  //     this.noOfYeararray.push({"key":yearString, "value":(i + 1), "label": yearString.replace(" ",""), "proposedCostTotal": 0, "costofConsumableTotal": 0});
  //   }
  //   this.dynamicColumnCount = this.noOfYeararray.length + 1;
  //   if(resetTable){
  //     this.loadCostItemData();
  //     this.noOfYearisReset = true;
  //     // const manpowerArray = <FormArray>this.manpowerForm.controls['manpowerArray'];
  //     // manpowerArray.push(this.initManpowerRow(null,false));

  //     // const consumablesRowArray = <FormArray>this.consumablesForm.controls['consumablesArray'];
  //     // consumablesRowArray.push(this.initConsumablesRow(null, false));

  //     // const travelRowArray = <FormArray>this.travelForm.controls['travelArray'];
  //     // travelRowArray.push(this.initTravelRow(null, false));
  //   }
  // }

  // setNoofYears(value: any, resetTable: any){
  //   //alert(value);
  //   const control = <FormArray>this.proposedCostForm.controls['proposedCostArray'];
  //   control.clear();
  //   this.format2.controls.allTotalCost.setValue(0);

  //   const manPowerControl = <FormArray>this.manpowerForm.controls['manpowerArray'];
  //   manPowerControl.clear();

  //   const costofConsumableControl = <FormArray>this.consumablesForm.controls['consumablesArray'];
  //   costofConsumableControl.clear();

  //   const travelRowArray = <FormArray>this.travelForm.controls['travelArray'];
  //   travelRowArray.clear();

  //   this.noOfyear = (value / 12);
  //   this.noOfYeararray = [];
  //   for(var i= 0; i< this.noOfyear; i++){
  //     let yearString =  converter.toWordsOrdinal((i + 1)) + " " + "Year";
  //     this.noOfYeararray.push({"key":yearString, "value":(i + 1), "label": yearString.replace(" ",""), "proposedCostTotal": 0, "costofConsumableTotal": 0});
  //   }
  //   this.dynamicColumnCount = this.noOfYeararray.length + 1;
  //   if(resetTable){
  //     this.loadCostItemData();
  //     this.noOfYearisReset = true;
  //      const manpowerArray = <FormArray>this.manpowerForm.controls['manpowerArray'];
  //      manpowerArray.push(this.initManpowerRow(null,false));

  //      const consumablesRowArray = <FormArray>this.consumablesForm.controls['consumablesArray'];
  //      consumablesRowArray.push(this.initConsumablesRow(null, false));

  //     const travelRowArray = <FormArray>this.travelForm.controls['travelArray'];
  //     travelRowArray.push(this.initTravelRow(null, false));
  //   }
  // }

  ngOnInit(): void {
    this.checkTime();
    setInterval(() => this.checkTime(), 1000);
    //(() => this.checkTime(), 1000);
    //this.setNoofYears1(60,true);
    //this.getstateDetails();
    this.documentURL = environment.documentURL;
    this.route.params.subscribe(parmas => {
      this.applicationID = parmas["id"];
    });
    
    this.horizontalWizardStepper = new Stepper(document.querySelector('#stepper1'), {});
    //this.loadProjectTypeData();
    //this.loadSubjectTypeData(false);
    
   // this.loadPrincipalImplementingData();
    //this.loadCategoryImplementingData();
    //this.loadBudgetCostData();
    //this.loadUnits();
    // Subscribe to config changes
    // this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
    //   this.coreConfig = config;
    // });
    
    // content header
    this.contentHeader = {
      headerTitle: 'EU-TTC Proposal',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'EU-TTC Proposal',
            isLink: false,
            link: '/euttc-proposal'
          },
          // {
          //   name: 'eCommerce',
          //   isLink: true,
          //   link: '/'
          // },
          // {
          //   name: 'Shop',
          //   isLink: true,
          //   link: '/'
          // },
          // {
          //   name: 'Details',
          //   isLink: false
          // }
        ]
      }
    };

    this.contactDetailsForm = this._formBuilder.group({
      contactDetailsArray: this._formBuilder.array([])
    });

    this.totalCostForm = this._formBuilder.group({
      costArray: this._formBuilder.array([])
    });

    this.projectPlanForm = this._formBuilder.group({
      projectPlanArray: this._formBuilder.array([])
    });

    this.proposedCostForm = this._formBuilder.group({
      proposedCostArray: this._formBuilder.array([])
    });

    this.equipmentForm = this._formBuilder.group({
      equipmentArray: this._formBuilder.array([])
    });

    this.manpowerForm = this._formBuilder.group({
      manpowerArray: this._formBuilder.array([])
    });

    this.consumablesForm = this._formBuilder.group({
      consumablesArray: this._formBuilder.array([])
    });

    this.travelForm = this._formBuilder.group({
      travelArray: this._formBuilder.array([])
    });
    
    // if(this.applicationID != undefined){
    //   this.getCoeApplicationDetails(this.applicationID);
      
    // }

    // if(this.applicationID == undefined){
    //   const contactDetailArray = <FormArray>this.contactDetailsForm.controls['contactDetailsArray'];
    //   contactDetailArray.push(this.initContactDetailRow(null,false));

    //   const costArray = <FormArray>this.totalCostForm.controls['costArray'];
    //   costArray.push(this.initCostRow(null,false));

    //   const projectPlanArray = <FormArray>this.projectPlanForm.controls['projectPlanArray'];
    //   projectPlanArray.push(this.initProjectPlanRow(null,false));
    
    //   //this.loadCostItemData();

    //   const equipmentRowArray = <FormArray>this.equipmentForm.controls['equipmentArray'];
    //   equipmentRowArray.push(this.initEquipmentRow(null,false));

    //   const manpowerArray = <FormArray>this.manpowerForm.controls['manpowerArray'];
    //   manpowerArray.push(this.initManpowerRow(null,false));

    //   const consumablesArray = <FormArray>this.consumablesForm.controls['consumablesArray'];
    //   consumablesArray.push(this.initConsumablesRow(null,false));

    //   const travelArray = <FormArray>this.travelForm.controls['travelArray'];
    //   travelArray.push(this.initTravelRow(null,false));
    // }
  }

  checkTime() {
    const now = new Date();
    this.hideButton = now >= this.targetDate;
    }

  // ngAfterViewChecked(): void {
  //   this.changeDetectorRef.detectChanges();
  //   }

    

  // public applicationDetail: any;
  // getCoeApplicationDetails(id: any){
  //   const data = {
  //     applyonlineId: id
  //   }
  //   this._applyOnlineEuttcService.getCoeApplicationDetail(data).subscribe((result: any) => {

  //     this.applicationDetail = null;
  //     if (result.statusCode == statusCode.SUCCESS) {

  //       this.applicationDetail 	= result["data"]["response"];
  //       //this.getSubjectAreaId 	= this.applicationDetail.subjectArea.split(',');
  //       //this.loadSubjectTypeData(true);
  //       //alert(this.applicationDetail.coPrincipalDetail);
  //       this.format1.controls.ApplicantCategory.setValue(this.applicationDetail.applicantCategory);
  //       //this.format1.controls.CoPrincipalDetails.setValue(this.applicationDetail.coPrincipalDetail);
  //       this.format1.controls.ProjectTitle.setValue(this.applicationDetail.projectTitle);
  //       //this.format1.controls.AreaOfResearch.setValue(JSON.parse("[" + this.applicationDetail.areaOfResearch + "]"));
  //       this.format1.controls.Objectives.setValue(this.applicationDetail.objectives);
  //       //this.format1.controls.Duration.setValue(this.applicationDetail.duration);
  //       this.format1.controls.TotalCostMnreShare.setValue(this.applicationDetail.totalCostMnreShare);
  //       this.format1.controls.PiName.setValue(this.applicationDetail.piName);
  //       this.format1.controls.PiTelephone.setValue(this.applicationDetail.piTelephone);
  //       this.format1.controls.PiFax.setValue(this.applicationDetail.piFax);
  //       this.format1.controls.PiEmail.setValue(this.applicationDetail.piEmail);
  //       this.format1.controls.CoPiName.setValue(this.applicationDetail.coPiName);
  //       this.format1.controls.CoPiTelephone.setValue(this.applicationDetail.coPiTelephone);
  //       this.format1.controls.CoPiFax.setValue(this.applicationDetail.coPiFax);
  //       this.format1.controls.CoPiEmail.setValue(this.applicationDetail.coPiEmail);
  //       this.format1.controls.AdditionalCoPiDetail.setValue(this.applicationDetail.additionalCoPiDetail);
  //       this.format1.controls.SourceBalanceCost.setValue(this.applicationDetail.sourceBalanceCost);
  //       this.format1.controls.StatusOfWork.setValue(this.applicationDetail.statusOfWork);
  //       this.format1.controls.PilotTechnologyDetail.setValue(this.applicationDetail.pilotTechnologyDetail);
  //       this.format1.controls.Summary.setValue(this.applicationDetail.summary);
  //       this.format1.controls.Timelines.setValue(this.applicationDetail.timelines);
  //       this.format1.controls.DetailFunctioning.setValue(this.applicationDetail.detailFunctioning);
  //       this.format1.controls.principaIinvestigatorCvFile.setValue(this.applicationDetail.pICvFileName);
  //       this.format1.controls.CoPrincipaIinvestigatorCvFile.setValue(this.applicationDetail.coPICvFileName);
  //       this.format1.controls.SubstantiatedLettersFile.setValue(this.applicationDetail.subLettersFileName);
  //       // this.format1.controls.ProjectType.setValue(this.applicationDetail.projectType);
  //       // this.format1.controls.PrincipalImplementingOnganizations.setValue(this.applicationDetail.principalImplementingOrganization);
  //       // this.setNoofYears(this.applicationDetail.duration, false);
  //       // this.format1.controls.Gender.setValue(this.applicationDetail.gender);
  //       // this.format1.controls.casteCategory.setValue(this.applicationDetail.caste_category);
  //       // this.format1.controls.Address.setValue(this.applicationDetail.address);
  //       // this.format1.controls.PinCode.setValue(this.applicationDetail.pincode);
  //       // this.format1.controls.State.setValue(this.applicationDetail.state);
  //       // this.format1.controls.District.setValue(this.applicationDetail.district);
  //       // this.format1.controls.CategoryOfInstitution.setValue(this.applicationDetail.categoryImpInstitution);
  //       // this.format1.controls.Collaborating.setValue(this.applicationDetail.collaboratingOrg);
  //       // this.format1.controls.PrincipalInvestigator.setValue(this.applicationDetail.principleInvestigator);
  //       // this.format1.controls.Shareofimplementing.setValue(this.applicationDetail.shareImplementing);
  //       // this.format1.controls.NeedOfTheProjectOutcome.setValue(this.applicationDetail.viabilityOfProduct);
  //       // this.format1.controls.StatusOfWork.setValue(this.applicationDetail.statusOfWork);
  //       // if(this.applicationDetail.state > 0){
  //       // 	this._commonService.getDistrictData(this.applicationDetail.state).subscribe((result: any) => {
  //       // 		this.cityArray = [];
  //       // 		if (result.statusCode == 200) {
  //       // 			result["data"]["response"].forEach(element => {
  //       // 				this.cityArray.push({
  //       // 					districtName: element.districtTitle,
  //       // 		            districtID: element.id
  //       // 				});
  //       // 			});
  //       // 		}
            
  //       // 	});
  //       // }
        
  //       if(this.applicationDetail.leadPartner != null && this.applicationDetail.leadPartner != undefined && this.applicationDetail.leadPartner != ''){
  //         this.displayLeadPartnerField = true;
  //         this.format1.controls.LeadPartner.setValue(this.applicationDetail.leadPartner);
  //       }
  //       else{
  //         this.displayLeadPartnerField = false;
  //       }
  //       // if(this.applicationDetail.coPrincipalDetail != null && this.applicationDetail.coPrincipalDetail != undefined && this.applicationDetail.coPrincipalDetail != ''){
  //       // 	this.displayCoPrincipalField = true;
  //       // 	this.format1.controls.CoPiName.setValue(this.applicationDetail.coPiName);
  //       //     this.format1.controls.CoPiTelephone.setValue(this.applicationDetail.coPiTelephone);
  //       //     this.format1.controls.CoPiFax.setValue(this.applicationDetail.coPiFax);
  //       //     this.format1.controls.CoPiEmail.setValue(this.applicationDetail.coPiEmail);
  //       // }
  //       // else{
  //       // 	this.displayCoPrincipalField = false;
  //       // }
  //       // if(this.applicationDetail.contactDetailsArray.length > 0)
  //       // {
  //       // 	this.applicationDetail.contactDetailsArray.forEach(element => {
  //       // 		const contactDetailArray = <FormArray>this.contactDetailsForm.controls['contactDetailsArray'];
  //       // 		contactDetailArray.push(this.initContactDetailRow(element,true));
  //       // 	});
  //       // }
  //       // else{
  //       // 	const contactDetailArray = <FormArray>this.contactDetailsForm.controls['contactDetailsArray'];
  //       // 	contactDetailArray.push(this.initContactDetailRow(null,false));
  //       // }

  //       if(this.applicationDetail.totalCostAction.length > 0)
  //       {
  //         let indexes = 0;
  //         let isEditCost 	= 1;
  //         this.applicationDetail.totalCostAction.forEach(element => {
  //           const costArray = <FormArray>this.totalCostForm.controls['costArray'];
  //           costArray.push(this.initCostRow(element,true));
  //           this.setAllFieldTotalCost(indexes,isEditCost);
  //           indexes++;
  //         });
  //       }
  //       else{
  //           const costArray = <FormArray>this.totalCostForm.controls['costArray'];
  //           costArray.push(this.initCostRow(null,false));
  //       }
  //       this.tempTotalCostArray = <FormArray>this.totalCostForm.controls['costArray'].value;

  //       if(this.applicationDetail.timeline.length > 0)
  //       {
  //         this.applicationDetail.timeline.forEach(element => {
  //           const projectPlanArray = <FormArray>this.projectPlanForm.controls['projectPlanArray'];
  //           projectPlanArray.push(this.initProjectPlanRow(element,true));
  //         });
  //       }
  //       else{
  //           const projectPlanArray = <FormArray>this.projectPlanForm.controls['projectPlanArray'];
  //           projectPlanArray.push(this.initProjectPlanRow(null,false));
  //       }
  //       if(this.applicationDetail.proposedCostArray.length > 0)
  //       {
  //         let index = 0;
  //         this.applicationDetail.proposedCostArray.forEach(element => {
  //           const proposedCostArray = <FormArray>this.proposedCostForm.controls['proposedCostArray'];
  //           proposedCostArray.push(this.initProposedCostRow(element.proposedCostItem, element.proposedCostItemId, element, true));
  //           this.setAllFieldTotal(index);
  //           index++;
  //         });
  //       }
  //       else{
  //         this.loadCostItemData();
  //       }

  //       this.format2.controls.ProjectDeliverables.setValue(this.applicationDetail.projectDeliverables);
  //       this.format2.controls.PotentialUsersAndSuggestedPlan.setValue(this.applicationDetail.scalabilityAndBankability);
  //       this.format2.controls.CertificateRemarks.setValue(this.applicationDetail.investigatorGranteeOrg);
  //       //this.format2.controls.CertificateFileName.setValue(this.applicationDetail.investigatorGranteeOrgFile);
  //       this.format2.controls.DetailofAnnexureFirstFile.setValue(this.applicationDetail.annexureFirstFile);


  //       this.format2.controls.InfrastructuralFacilites.setValue(this.applicationDetail.hostInstitution);
  //       //this.format2.controls.InfrastructuralFacilitesFileName.setValue(this.applicationDetail.hostInstitutionFile);
  //       this.format2.controls.DetailofAnnexureSecondFile.setValue(this.applicationDetail.annexureSecondFile);


        
  //       this.format2.controls.CSVOfPIRemarks.setValue(this.applicationDetail.costStatus);// 
  //       //this.format2.controls.CSVOfPIFileName.setValue(this.applicationDetail.costStatusFile);// costStatusFile
  //       this.format2.controls.DetailofAnnexureThirdFile.setValue(this.applicationDetail.annexureThirdFile);// costStatusFile

  //       //this.format2.controls.DetailofReserchFileName.setValue(this.applicationDetail.researchMethodologyFile);// costStatusFile
  //       this.format2.controls.DetailofAnnexureFourthFile.setValue(this.applicationDetail.annexureFourthFile);// costStatusFile
  //               this.format2.controls.DetailofAnnexureSecondDFile.setValue(this.applicationDetail.annexureSecondDFile);
  //       this.format2.controls.DetailofAnnexureSecondEFile.setValue(this.applicationDetail.annexureSecondEFile);
  //       if(this.applicationDetail.costEquipmentArray.length > 0)
  //       {
  //         this.applicationDetail.costEquipmentArray.forEach(element => {
  //           const equipmentRowArray = <FormArray>this.equipmentForm.controls['equipmentArray'];
  //           equipmentRowArray.push(this.initEquipmentRow(element,true));
  //         });
  //       }
  //       else{	
  //           const equipmentRowArray = <FormArray>this.equipmentForm.controls['equipmentArray'];
  //           equipmentRowArray.push(this.initEquipmentRow(null,false));
  //       }
  //       if(this.applicationDetail.mapPowerCostArray.length > 0 && !this.noOfYearisReset)
  //       {
  //         let index = 0;
  //         this.applicationDetail.mapPowerCostArray.forEach(element => {
  //           const manpowerArray = <FormArray>this.manpowerForm.controls['manpowerArray'];
  //           manpowerArray.push(this.initManpowerRow(element,true));
  //           this.setManPowerYearTotal(index);
  //           index++;
  //         });
  //       }
  //       else{
  //         const manpowerArray = <FormArray>this.manpowerForm.controls['manpowerArray'];
  //         manpowerArray.push(this.initManpowerRow(null,false));
  //       }

  //       if(this.applicationDetail.consumablesArray.length > 0  && !this.noOfYearisReset)
  //       {
  //         //let index = 0;
  //         this.applicationDetail.consumablesArray.forEach(element => {
  //           const consumablesArray = <FormArray>this.consumablesForm.controls['consumablesArray'];
  //           consumablesArray.push(this.initConsumablesRow(element,true));
  //           //index++;
  //         });
  //         this.setConsumablesFormFieldTotal();
  //       }
  //       else{
  //         const consumablesArray = <FormArray>this.consumablesForm.controls['consumablesArray'];
  //         consumablesArray.push(this.initConsumablesRow(null,false));
  //       }
  //       if(this.applicationDetail.travelArray.length > 0 && !this.noOfYearisReset)
  //       {
  //         let index = 0;
  //         this.applicationDetail.travelArray.forEach(element => {
  //           const travelArray = <FormArray>this.travelForm.controls['travelArray'];
  //           travelArray.push(this.initTravelRow(element,true));
  //           this.setTravelCostTotal(index);
  //           index++;
  //         });
  //       }
  //       else{
  //         const travelArray = <FormArray>this.travelForm.controls['travelArray'];
  //         travelArray.push(this.initTravelRow(null,false));
  //       }
  //     }
  //   })
  // }

  // browsbuttonClick(type) {
    
  //   if (type === "applicantFile") {
  //     this.format1.controls.CoPrincipalInvestigatorCVName.setValue('Select file');
  //   }
  //   else if (type === "principaIinvestigatorCv") {
  //     this.format1.controls.principaIinvestigatorCvFileName.setValue('Select file');
  //   }
  //   else if (type === "coprincipaIinvestigatorCv") {
  //     this.format1.controls.CoPrincipaIinvestigatorCvFileName.setValue('Select file');
  //   }
  //   else if (type === "substantiatedLetters") {
  //     this.format1.controls.SubstantiatedLettersFileName.setValue('Select file');
  //   }
  //   // else if (type === "annexureFirstFile") {
      
  //   // 	this.format2.controls.DetailofAnnexureFirstFile.setValue('Select file');
  //   // }
  //   // else if (type === "DetailofAnnexureSecondAFile") {
  //   // 	this.format2.controls.DetailofAnnexureSecondAFile.setValue('Select file');
  //   // }
  //   else if (type === "availabilityOfEquipmentsFile") {
  //     this.format2.controls.AvailibilityEquipmentsFileName.setValue('Select file');
  //   }
  //   // else if (type === "annexureThirdFile") {
  //   // 	this.format2.controls.DetailofAnnexureThirdFile.setValue('Select file');
  //   // }
  //   // else if (type === "annexureFourthFile") {
  //   // 	this.format2.controls.DetailofAnnexureFourthFile.setValue('Select file');
  //   // }
  //   // else if (type === "annexureSecondDFile") {
  //   // 	this.format2.controls.DetailofAnnexureSecondDFile.setValue('Select file');
  //   // }
  //   // else if (type === "annexureSecondEFile") {
  //   // 	this.format2.controls.DetailofAnnexureSecondEFile.setValue('Select file');
  //   // }
  //   this.removeFile(type, 0, this.myFiles);
  // }

  // browsArrayFileObject(type, index) {
  //   if (type === "costEquipmentFileList") {
  //     this.equipmentForm.controls.equipmentArray["controls"][index].controls.fileName.setValue("Select file");
  //   }
  //   else if (type === "mapPowerFileList") {
  //     this.manpowerForm.controls.manpowerArray["controls"][index].controls.fileName.setValue("Select file");
  //   }
  //   this.removeFile(type, index, this.myFilesStep3);
  // }

  // removeFile(type, index, dataList){
  //   var key = type + "[" + index + "]";
  //     if(dataList.length > 0){
  //       dataList.forEach((element, i) => {
  //         if(element.key == key){
  //           dataList.splice(i, 1);
  //         }
  //       });
  //     }
  // }

  // setChartData() {
  //   var projectPlanArrayList = this.projectPlanForm.value.projectPlanArray;
    
  //   let data = [];
  //   if (projectPlanArrayList.length > 0) {
  //     projectPlanArrayList.forEach(element => {
  //       if (element.startDate != null && element.endDate != null && element.name != null) {
  //         let startDate = element.startDate.year + '-' + element.startDate.month + '-' + (element.startDate.day);
  //         let endDate = element.endDate.year + '-' + element.endDate.month + '-' + (element.endDate.day);
          
  //         data.push({
  //           x: element.name,
  //           y: [new Date(startDate).getTime(),
  //           new Date(endDate).getTime()],
  //           fillColor: this.getRandomColor()
  //         })
  //       }
  //     });
  //   }

  //   this.chartOptions = {
  //     series: [
  //       {
  //         data: data
  //       }
  //     ],
  //     chart: {
  //       height: 350,
  //       type: "rangeBar",
  //       zoom: {
  //         enabled: false
  //       },
  //       toolbar: {
  //         show: false
  //       }
  //     },
  //     plotOptions: {
  //       bar: {
  //         horizontal: true,
  //         distributed: true,
  //         dataLabels: {
  //           hideOverflowingLabels: false
  //         }
  //       }
  //     },
  //     dataLabels: {
  //       enabled: true,
  //       formatter: function (val, opts) {
  //         var label = opts.w.globals.labels[opts.dataPointIndex];
  //         var a = moment(val[0]);
  //         var b = moment(val[1]);
  //         var diff = b.diff(a, "days");
  //         return label + ": " + diff + (diff > 1 ? " days" : " day");
  //       },
  //       style: {
  //         colors: ["#f3f4f5", "#fff"]
  //       }
  //     },
  //     xaxis: {
  //       type: "datetime"
  //     },
  //     yaxis: {
  //       show: false
  //     },
  //     grid: {
  //       row: {
  //         colors: ["#f3f4f5", "#fff"],
  //         opacity: 1
  //       }
  //     }
  //   };
  // }

  // getRandomColor() {
  //   var color = Math.floor(0x1000000 * Math.random()).toString(16);
  //   return '#' + ('000000' + color).slice(-6);
  // }

  // onFileChange(event: any, name: string, index: number, fileSize:any) {
    
  //   for (var i = 0; i < event.target.files.length; i++) {
  //     //this.myFiles = [];
  //     var fileType = event.target.files[0].name.split(".").pop();
  //     var size = event.target.files[i].size;
  //     size = (size / 1024 / 1024);
  //     if(size > fileSize){
  //       Swal.fire({
  //         title: 'Information',
  //         text: 'Slected file size is too Big, please select a file less than: ' + fileSize + ' MB:)',
  //         icon: 'info',
  //         customClass: {
  //           confirmButton: 'btn btn-success'
  //         }
  //       });
  //       return false;
  //     }
  //     if(fileType != 'pdf' && fileType != 'png' && fileType != 'jpg' && fileType != 'xls' && fileType != 'docx'){
  //       Swal.fire({
  //         title: 'Information',
  //         text: 'Invalid file type.',
  //         icon: 'info',
  //         customClass: {
  //           confirmButton: 'btn btn-success'
  //         }
  //       });
  //       return false;
  //     }
  //     this.tempFiles = [];
  //     this.tempFilesStep3 = [];
  //     var key = name + "[" + index + "]";
      
  //     if (name !== "costEquipmentFileList"){
  //       this.myFiles.push({ key: key, file: event.target.files[i] });
  //       this.tempFiles.push({ key: key, file: event.target.files[i] });
  //       if (name === 'applicantFile') {
  //         this.format1.controls.CoPrincipalInvestigatorCVName.setValue(this.showFiles(this.tempFiles));
  //       }
  //       else if (name === "principaIinvestigatorCv") {
  //         this.format1.controls.principaIinvestigatorCvFileName.setValue(this.showFiles(this.tempFiles));
  //       }
  //       else if (name === "coprincipaIinvestigatorCv") {
  //         this.format1.controls.CoPrincipaIinvestigatorCvFileName.setValue(this.showFiles(this.tempFiles));
  //       }
  //       else if (name === "substantiatedLetters") {
  //         this.format1.controls.SubstantiatedLettersFileName.setValue(this.showFiles(this.tempFiles));
  //       }
  //       // else if (name === "annexureFirstFile") {
  //       // 	this.format2.controls.DetailofAnnexureFirstFile.setValue(this.showFiles(this.tempFiles));
  //       // }
  //       // else if (name === "annexureSecondAFile") {
  //       // 	this.format2.controls.DetailofAnnexureSecondAFile.setValue(this.showFiles(this.tempFiles));
  //       // }
  //       else if (name === "availabilityOfEquipmentsFile") {
  //         this.format2.controls.AvailibilityEquipmentsFileName.setValue(this.showFiles(this.tempFiles));
  //       }
  //       // else if (name === "annexureThirdFile") {
  //       // 	this.format2.controls.DetailofAnnexureThirdFile.setValue(this.showFiles(this.tempFiles));
  //       // }
  //       // else if (name === "annexureFourthFile") {
  //       // 	this.format2.controls.DetailofAnnexureFourthFile.setValue(this.showFiles(this.tempFiles));
  //       // }
  //       // else if (name === "annexureSecondDFile") {
  //       // 	this.format2.controls.DetailofAnnexureSecondDFile.setValue(this.showFiles(this.tempFiles));
  //       // }
  //       // else if (name === "annexureSecondEFile") {
  //       // 	this.format2.controls.DetailofAnnexureSecondEFile.setValue(this.showFiles(this.tempFiles));
  //       // }
  //     }
  //     else{
  //       this.myFilesStep3.push({ key: key, file: event.target.files[i] });
  //       this.tempFilesStep3.push({ key: key, file: event.target.files[i] });
  //       if (name === "costEquipmentFileList") {
  //         this.equipmentForm.controls.equipmentArray["controls"][index].controls.fileName.setValue(this.showFiles(this.tempFilesStep3));
  //       }
  //       else if (name === "principaIinvestigatorCv") {
  //         this.format1.controls.principaIinvestigatorCvFileName.setValue(this.showFiles(this.tempFiles));
  //       }
  //       // else if (name === "mapPowerFileList") {
  //       // 	this.manpowerForm.controls.manpowerArray["controls"][index].controls.fileName.setValue(this.showFiles(this.tempFiles));
  //       // }
  //     }
      
  //   }
  // }


  


  // trackByFn(item: any) {
  //   return item.id;
  // }

  // loadBudgetCostData() {
  //   this._commonService.getParameterSettings(ParentParameters.BUDGET_TYPE).subscribe((result: any) => {
  //     this.budgetType = [];
  //     if (result.statusCode == 200) {
  //       // this.budgetType.push({
  //       // 	budgetTypeName: "Select Cost Type",
  //       // 	budgetTypeID: 0
  //       // });
  //       result["data"]["response"].forEach(element => {
  //         this.budgetType.push({
  //           budgetTypeName: element.paraDescription,
  //           budgetTypeID: element.paraId
  //         });
  //       });
  //     }
  //   });
  // }

  // loadUnits(){
  //   this._commonService.getParameterSettings(ParentParameters.UNITS).subscribe((result: any) => {
  //     this.unitsType = [];
  //     if (result.statusCode == 200) {
  //       result["data"]["response"].forEach(element => {
  //         this.unitsType.push({
  //           unitsTypeName: element.paraDescription,
  //           unitsTypeID: element.paraId
  //         });
  //       });
  //     }
  //   });
  // }

  // loadProjectTypeData() {
  //   this._commonService.getParameterSettings(ParentParameters.PROJECTTYPE).subscribe((result: any) => {
  //     this.projectType = [];
  //     if (result.statusCode == 200) {
  //       result["data"]["response"].forEach(element => {
  //         this.projectType.push({
  //           projectTypeName: element.paraDescription,
  //           projectTypeID: element.paraId
  //         });
  //       });
  //     }
  //   });
  // }

  // loadCostItemData() {
  //   this._commonService.getParameterSettings(ParentParameters.PROPOSED_COST_ITEM).subscribe((result: any) => {
  //     this.proposedCostItemList = [];
  //     if (result.statusCode == 200) {
  //       // const control = <FormArray>this.proposedCostForm.controls['proposedCostArray'];
  //       // control.clear();
  //       result["data"]["response"].forEach(element => {
  //         this.proposedCostItemList.push({
  //           proposedCostItemName: element.paraDescription,
  //           proposedCostItemID: element.paraId
  //         });
  //         const proposedCostArray = <FormArray>this.proposedCostForm.controls['proposedCostArray'];
  //         proposedCostArray.push(this.initProposedCostRow(element.paraDescription, element.paraId, null, false));
  //       });
  //     }
  //   });
  // }

  // loadPrincipalImplementingData() {
  //   this._commonService.getParameterSettings(ParentParameters.PRINCIPLIMPLEMENTING_APF1).subscribe((result: any) => {
  //     this.principalImplementing = [];
  //     if (result.statusCode == 200) {
  //       result["data"]["response"].forEach(element => {
  //         this.principalImplementing.push({
  //           princialImplementingName: element.paraDescription,
  //           princialImplementingID: element.paraId
  //         });
  //       });
  //     }
  //   });
  // }

  // loadCategoryImplementingData() {
  //   this._commonService.getParameterSettings(ParentParameters.CATIMPLEMENTINGINSTITUTION_APF1).subscribe((result: any) => {
  //     this.categoryOfInstitution = [];
  //     if (result.statusCode == 200) {
  //       result["data"]["response"].forEach(element => {
  //         this.categoryOfInstitution.push({
  //           categoryOfInstitutionName: element.paraDescription,
  //           categoryOfInstitutionID: element.paraId
  //         });
  //       });
  //     }
  //   });
  // }


  // initCostRow(element, isEdit): FormGroup {
  //   if(isEdit){
  //     return this._formBuilder.group({
  //       //id: [element.id],
  //       title: [element.title, [Validators.required,]],
  //       value: [element.value, [Validators.required]],
  //       isEdit: [true]
  //     });
  //   }
  //   else{
  //     return this._formBuilder.group({
  //       //id:[0],
  //       title: [, [Validators.required]],
  //       value: [null, [Validators.required]],
  //       isEdit: [false]
  //     });
  //   }
  // }

  // initProjectPlanRow(element, isEdit): FormGroup {
  //   if(isEdit){
  //     return this._formBuilder.group({
  //       //timelineID: [element.timelineID],
  //       name: [element.name, [Validators.required]],
  //       duration: [element.duration, [Validators.required]]
  //     });
  //   }
  //   else{
  //     return this._formBuilder.group({
  //       //timelineID:[0],
  //       name: [null, [Validators.required]],
  //       duration: [null, [Validators.required]]
  //     });
  //   }
  // }

  // initProposedCostRow(name: string, id: number, element, isEdit): FormGroup {
  //   if(isEdit){
  //     let form = this._formBuilder.group({
  //       proposedCostItemName: [element.proposedCostItemName],
  //       proposedCostItemID: [element.proposedCostItemID],
  //       totalCost: [isNaN(parseFloat(element.totalCost)) ? 0 : element.totalCost],
  //     });
  //     Object.keys(this.noOfYeararray).forEach(name => {
  //       let value = isNaN(parseFloat(element[this.noOfYeararray[name].label])) ? 0 :
  //       element[this.noOfYeararray[name].label].toString().includes(",") ? element[this.noOfYeararray[name].label].replaceAll(",","") : element[this.noOfYeararray[name].label];
  //       form.addControl(this.noOfYeararray[name].label, new FormControl(value, []));
  //       });
  //       return form;
  //   }
  //   else{
  //     let form = this._formBuilder.group({
  //       proposedCostItemName: [name],
  //       proposedCostItemID: [id],
  //       totalCost: [0],
  //       //param: this._formBuilder.group({})
  //     });
      
  //       Object.keys(this.noOfYeararray).forEach(name => {
  //         form.addControl(this.noOfYeararray[name].label, new FormControl(0, []));
  //     });
  //     return form;
  //   }
  // }

  // initEquipmentRow(element, isEdit): FormGroup {
  //   if(isEdit){
  //     return this._formBuilder.group({
  //       costEquipmentID:[element.costEquipmentID],
  //       equipmentName: [element.equipmentName, [Validators.required]],
  //       importedIndigenous: [element.importedIndigenous, [Validators.required]],
  //       estimatedCost: [element.estimatedCost, [Validators.required]],
  //       justification: [element.justification, [Validators.required]],
  //       costEquipmentFile:[element.costEquipmentFile],
  //       file: [],
  //       fileName: ["Select file"]
  //     });
  //   }
  //   else{
  //     return this._formBuilder.group({
  //       costEquipmentID:[0],
  //       equipmentName: ['', [Validators.required]],
  //       importedIndigenous: ['', [Validators.required]],
  //       estimatedCost: ['', [Validators.required]],
  //       justification: ['', [Validators.required]],
  //       costEquipmentFile:[''],
  //       file: [],
  //       fileName: ["Select file"]
  //     });
  //   }
    
  // }

  // initManpowerRow(element, isEdit): FormGroup {
  //   if(isEdit){
  //     let form = this._formBuilder.group({
  //       //mapPowerCostID:[element.mapPowerCostID],
  //       designation: [element.designation, [Validators.required]],
  //       justification: [element.justification, [Validators.required]],
  //       monthlyEmoluments: [element.monthlyEmoluments.toString().includes(",") ? element.monthlyEmoluments.replaceAll(",","") : element.monthlyEmoluments, [Validators.required]],
  //       total: [element.total, [Validators.required]],
  //     });
  //     Object.keys(this.noOfYeararray).forEach(name => {
  //       let value = isNaN(parseFloat(element[this.noOfYeararray[name].label])) ? 0 :
  //       element[this.noOfYeararray[name].label].toString().includes(",") ? element[this.noOfYeararray[name].label].replaceAll(",","") : 
  //       element[this.noOfYeararray[name].label];
  //       form.addControl(this.noOfYeararray[name].label, new FormControl(value, []));
  //       });
  //     return form;
  //   }
  //   else{
  //     let form = this._formBuilder.group({
  //       //mapPowerCostID:[0],
  //       designation: ['', [Validators.required]],
  //       justification: ['', [Validators.required]],
  //       monthlyEmoluments: ['', [Validators.required]],
  //       total: [0, [Validators.required]],
  //     });
  //     Object.keys(this.noOfYeararray).forEach(name => {
  //       form.addControl(this.noOfYeararray[name].label, new FormControl(0, []));
  //     });
  //     return form;
  //   }
    
  // }

  // initConsumablesRow(element, isEdit): FormGroup {
  //   if(isEdit){
  //     let form = this._formBuilder.group({
  //       //consumablesID:[element.consumablesID],
  //       item: [element.item, [Validators.required]],
  //       qty : [element.qty, [Validators.required]],
  //       unit: [element.unit, [Validators.required]],
  //       unitName:[element.unitName,[]]
  //     });
  //     Object.keys(this.noOfYeararray).forEach(name => {
  //       let value = isNaN(parseFloat(element[this.noOfYeararray[name].label])) ? 0 :
  //       element[this.noOfYeararray[name].label].toString().includes(",") ? element[this.noOfYeararray[name].label].replaceAll(",","") : 
  //       element[this.noOfYeararray[name].label];
  //       form.addControl(this.noOfYeararray[name].label, new FormControl(value, []));
  //       });
  //     return form;
  //   }
  //   else{
  //     let form = this._formBuilder.group({
  //       //consumablesID:[0],
  //       item: ['', [Validators.required]],
  //       qty : ['', [Validators.required]],
  //       unit: [136003, [Validators.required]],
  //       unitName:['Kg',[]]
  //     });
  //     Object.keys(this.noOfYeararray).forEach(name => {
  //       form.addControl(this.noOfYeararray[name].label, new FormControl(0, []));
  //     });
  //     return form;
  //   }
  // }
  
  // initTravelRow(element, isEdit): FormGroup {
  //   if(isEdit){
  //     let form = this._formBuilder.group({
  //       //travelCostID:[element.travelCostID],
  //       title: [element.title, [Validators.required]],
  //       justification: [element.justification, [Validators.required]],
  //       total: [element.total, [Validators.required]]
  //     });
  //     Object.keys(this.noOfYeararray).forEach(name => {
  //       let value = isNaN(parseFloat(element[this.noOfYeararray[name].label])) ? 0 :
  //       element[this.noOfYeararray[name].label].toString().includes(",") ? element[this.noOfYeararray[name].label].replaceAll(",","") : 
  //       element[this.noOfYeararray[name].label];
  //       form.addControl(this.noOfYeararray[name].label, new FormControl(value, []));
  //       });
  //     return form;
  //   }
  //   else{
  //     let form = this._formBuilder.group({
  //       //travelCostID: [0],
  //       title: ['', [Validators.required]],
  //       justification: ['', [Validators.required]],
  //       total: ['', [Validators.required]]
  //     });
  //     Object.keys(this.noOfYeararray).forEach(name => {
  //       form.addControl(this.noOfYeararray[name].label, new FormControl(0, []));
  //     });
  //     return form;
  //   }
    
  // }

  /**
  * On destroy
  */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
  /**
   * Get FormData
   */
  get f1() {
    return this.format1.controls;
  }

  get f2() {
    return this.format2.controls;
  }

  get f3() {
    return this.format3.controls;
  }

  get f4() {
    return this.format4.controls;
  }

  get f5() {
    return this.format5.controls;
  }


  public isvalidData(data){
    if(data !='' && data != null && data != undefined){
      return true;
    }
    return false;
  }

  

  annexureFirstFileUpload(event:any)
  {
    this.annexureFirstFile = event.target.files[0];
  if (this.annexureFirstFile.type !== 'application/pdf') {
    alert('Only PDF files are allowed!');
    this.format1.controls.DetailofAnnexureFirstFile.setValue("");
        return false;
      }
    const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024; // Convert MB to Bytes
    if (this.annexureFirstFile.size > maxSizeInBytes) {
    alert('File size exceeds the allowed limit of 10 MB');
    this.format1.controls.DetailofAnnexureFirstFile.setValue("");
        return false;
      }
  this.format1.controls.DetailofAnnexureFirstFile.setValue(this.annexureFirstFile.name);
  }

  // annexureSecondFileUpload(event:any)
  // {
  //   this.annexureSecondFile = event.target.files[0];
  // if (this.annexureSecondFile.type !== 'application/pdf') {
  //   alert('Only PDF files are allowed!');
  //   this.format2.controls.DetailofAnnexureSecondFile.setValue("");
  //       return false;
  //     }

  //   const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024; // Convert MB to Bytes
  //   if (this.annexureSecondFile.size > maxSizeInBytes) {
  //   alert('File size exceeds the allowed limit of 5 MB');
  //   this.format2.controls.DetailofAnnexureSecondFile.setValue("");
  //       return false;
  //     }

  // this.format2.controls.DetailofAnnexureSecondFile.setValue(this.annexureSecondFile.name);
  // }

  // annexureThirdFileUpload(event:any)
  // {
  //   this.annexureThirdFile = event.target.files[0];
  // if (this.annexureThirdFile.type !== 'application/pdf') {
  //   alert('Only PDF files are allowed!');
  //   this.format2.controls.DetailofAnnexureThirdFile.setValue("");
  //       return false;
  //     }
  //   const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024; // Convert MB to Bytes
  //   if (this.annexureThirdFile.size > maxSizeInBytes) {
  //   alert('File size exceeds the allowed limit of 5 MB');
  //   this.format2.controls.DetailofAnnexureThirdFile.setValue("");
  //       return false;
  //     }
  // this.format2.controls.DetailofAnnexureThirdFile.setValue(this.annexureThirdFile.name);
  // }

  // annexureFourthFileUpload(event:any)
  // {
  //   this.annexureFourthFile = event.target.files[0];
  // if (this.annexureFourthFile.type !== 'application/pdf') {
  //   alert('Only PDF files are allowed!');
  //   this.format2.controls.DetailofAnnexureFourthFile.setValue("");
  //       return false;
  //     }
  //   const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024; // Convert MB to Bytes
  //   if (this.annexureFourthFile.size > maxSizeInBytes) {
  //   alert('File size exceeds the allowed limit of 5 MB');
  //   this.format2.controls.DetailofAnnexureFourthFile.setValue("");
  //       return false;
  //     }
  // this.format2.controls.DetailofAnnexureFourthFile.setValue(this.annexureFourthFile.name);
  // }

  // annexureSecondDFileUpload(event:any)
  // {
  //   this.annexureSecondDFile = event.target.files[0];
  // if (this.annexureSecondDFile.type !== 'application/pdf') {
  //   alert('Only PDF files are allowed!');
  //   this.format2.controls.DetailofAnnexureSecondDFile.setValue("");
  //       return false;
  //     }
  //   const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024; // Convert MB to Bytes
  //   if (this.annexureSecondDFile.size > maxSizeInBytes) {
  //   alert('File size exceeds the allowed limit of 5 MB');
  //   this.format2.controls.DetailofAnnexureSecondDFile.setValue("");
  //       return false;
  //     }
  // this.format2.controls.DetailofAnnexureSecondDFile.setValue(this.annexureSecondDFile.name);
  // }

  // annexureSecondEFileUpload(event:any)
  // {
  //   this.annexureSecondEFile = event.target.files[0];
  // if (this.annexureSecondEFile.type !== 'application/pdf') {
  //   alert('Only PDF files are allowed!');
  //   this.format2.controls.DetailofAnnexureSecondEFile.setValue("");
  //       return false;
  //     }
  //   const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024; // Convert MB to Bytes
  //   if (this.annexureSecondEFile.size > maxSizeInBytes) {
  //   alert('File size exceeds the allowed limit of 5 MB');
  //   this.format2.controls.DetailofAnnexureSecondEFile.setValue("");
  //       return false;
  //     }
  // this.format2.controls.DetailofAnnexureSecondEFile.setValue(this.annexureSecondEFile.name);
  // }




  private prepareStep1Data(): any{
    let input: FormData = new FormData();
    input.append('projectTitle', this.format1.controls.ProjectTitle.value);
    input.append('summary', this.format1.controls.Summary.value);
    if(this.annexureFirstFile){
      input.append("annexureFirstFile", this.annexureFirstFile, this.annexureFirstFile.name);
      }
      // if(this.annexureSecondFile){
      //   input.append("annexureSecondFile", this.annexureSecondFile, this.annexureSecondFile.name);
      // }
      // if(this.annexureThirdFile){
      //   input.append("annexureThirdFile", this.annexureThirdFile, this.annexureThirdFile.name);
      // }
      // if(this.annexureFourthFile){
      //   input.append("annexureFourthFile", this.annexureFourthFile, this.annexureFourthFile.name);
      // }
    return input;
  }

  submitStep1() {
    var result = confirm("I verified the entered information in the proposal");
    if (result) {
    const self = this;
    this.submitted = true;
    //this.clearLeadPartnerValidation();
    //this.clearCoPrincipalValidation();
    //this.clearprincipaIinvestigatorCvFileValidation();
    // if(!this.displayField){
    // 	this.clearValidation();
    // }
    if (this.format1.invalid) {
      this.scrollToTop();
      this.format1.markAllAsTouched();
      return false;
    }
   
    const data = self.prepareStep1Data();
    console.log(data);
    this.loading = true;
    this._applyOnlineEuttcService
      .submitStep1Data(data)
      .pipe(first())
      .subscribe(
        response => {
          if (Number(response["statusCode"]) === statusCode.SUCCESS) {
            this.isDisabled = false;
            this.submitted = false;
            Swal.fire({
              icon: 'success',
              title: 'Success!',
              text: 'Your proposal has been submitted successfully.',
              customClass: {
                confirmButton: 'btn btn-success'
              }
            });
            this._router.navigate(['/euttc-application']);
          }
          // if (Number(response["statusCode"]) === statusCode.SUCCESS) {
          //   if(this.applicationID == undefined){
          //     this.applicationID = response["data"].encodedId;
          //   }
          //   this.horizontalWizardStepperNext(this.format1);
          // }

          else {
            this.loading = false;
            Swal.fire({
              icon: 'error',
              title: 'Error!',
              text: response["message"],
              customClass: {
                confirmButton: 'btn btn-error'
              }
            });
          }
        },
        error => {
          //this.error = error;
          this.isDisabled = false;
          this.loading = false;
          Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: error,
            customClass: {
              confirmButton: 'btn btn-error'
            }
          });
        }
      );
    return false;
    }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    }

 

  // private prepareStep2Data(): any{
  //   let input: FormData = new FormData();
  //   var projectPlanArrayList = this.projectPlanForm.value.projectPlanArray.filter(a=> this.isvalidData(a.name) && this.isvalidData(a.duration));
  //   var proposedCostListArray = this.proposedCostForm.value.proposedCostArray;
  //   let timelineArray = [];
  //   if (projectPlanArrayList.length > 0) {
  //     projectPlanArrayList.forEach(element => {
  //       timelineArray.push({
  //         name: element.name,
  //         duration: element.duration
  //       })
  //     });
  //   }

  //   input.append('applyonlineId', (this.applicationID != undefined) ? this.applicationID : 0);
  //   //input.append('timeline', timelineArray.length > 0 ? JSON.stringify(timelineArray) : "")
  //   input.append('proposedCostArray', proposedCostListArray.length > 0 ? JSON.stringify(proposedCostListArray) : "");
  //   if(this.annexureFirstFile){
  //        input.append("annexureFirstFile", this.annexureFirstFile, this.annexureFirstFile.name);
  //   }
  //   if(this.annexureSecondFile){
  //     input.append("annexureSecondFile", this.annexureSecondFile, this.annexureSecondFile.name);
  //   }
  //   if(this.annexureThirdFile){
  //     input.append("annexureThirdFile", this.annexureThirdFile, this.annexureThirdFile.name);
  //   }
  //   if(this.annexureFourthFile){
  //     input.append("annexureFourthFile", this.annexureFourthFile, this.annexureFourthFile.name);
  //   }
  //   if(this.annexureSecondDFile){
  //     input.append("annexureSecondDFile", this.annexureSecondDFile, this.annexureSecondDFile.name);
  //   }
  //   if(this.annexureSecondEFile){
  //     input.append("annexureSecondEFile", this.annexureSecondEFile, this.annexureSecondEFile.name);
  //   }
  //   //input.append("projectDeliverables", this.isvalidData(this.format2.controls.ProjectDeliverables.value) ? this.format2.controls.ProjectDeliverables.value : "");
  //   //input.append("scalabilityAndBankability", this.isvalidData(this.format2.controls.PotentialUsersAndSuggestedPlan.value) ? this.format2.controls.PotentialUsersAndSuggestedPlan.value : '');
  //   //input.append("investigatorGranteeOrg", this.isvalidData(this.format2.controls.CertificateRemarks.value) ? this.format2.controls.CertificateRemarks.value : '');
  //   //input.append("hostInstitution", this.isvalidData(this.format2.controls.InfrastructuralFacilites.value) ? this.format2.controls.InfrastructuralFacilites.value : "");
  //   //input.append("costStatus", this.isvalidData(this.format2.controls.CSVOfPIRemarks.value) ? this.format2.controls.CSVOfPIRemarks.value : "");
  //   for (var i = 0; i < this.myFiles.length; i++) {
  //     input.append(this.myFiles[i].key, this.myFiles[i].file);
  //   }
  //   return input;
  // }

  // submitStep2() {
  //   var result = confirm("I verified the entered information in the proposal");
  //   if (result) {
  //   const self = this;
  //   this.submitted = true;
  //   if (this.format2.invalid) {
  //     return false;
  //   }
  //   const data = self.prepareStep2Data();
    
  //   this.loading = true;
  //   this._applyOnlineEuttcService
  //     .submitStep2Data(data)
  //     .pipe(first())
  //     .subscribe(
  //       response => {
  //         if (Number(response["statusCode"]) === statusCode.SUCCESS) {
  //           this.isDisabled = false;
  //           this.submitted = false;
  //           Swal.fire({
  //             icon: 'success',
  //             title: 'Success!',
  //             text: 'Your proposal has been submitted successfully.',
  //             customClass: {
  //               confirmButton: 'btn btn-success'
  //             }
  //           });
  //           this._router.navigate(['/coe-application']);
  //         }
  //         else {
  //           this.isDisabled = false;
  //           this.loading = false;
  //           Swal.fire({
  //             icon: 'error',
  //             title: 'Error!',
  //             text: response["message"],
  //             customClass: {
  //               confirmButton: 'btn btn-error'
  //             }
  //           });
  //         }
  //       },
  //       error => {
  //         //this.error = error;
  //         this.isDisabled = false;
  //         this.loading = false;
  //         Swal.fire({
  //           icon: 'error',
  //           title: 'Error!',
  //           text: error,
  //           customClass: {
  //             confirmButton: 'btn btn-error'
  //           }
  //         });
  //       }
  //     );

  //   return false;
  // }
  // }

  // private prepareStep3Data(): any{
  //   let input: FormData = new FormData();
  //   var costEquipmentListArray = this.equipmentForm.value.equipmentArray.filter(a=> this.isvalidData(a.equipmentName) && this.isvalidData(a.importedIndigenous) && this.isvalidData(a.estimatedCost));
  //   var mapPowerCostListArray = this.manpowerForm.value.manpowerArray.filter(a=> this.isvalidData(a.designation) && this.isvalidData(a.monthlyEmoluments));
  //   var consumablesListArray = this.consumablesForm.value.consumablesArray.filter(a=>  this.isvalidData(a.item) && this.isvalidData(a.qty) && this.isvalidData(a.unit));
  //   input.append('applyonlineId', (this.applicationID != undefined) ? this.applicationID : 0);
  //   input.append('costEquipmentArray', costEquipmentListArray.length > 0 ? JSON.stringify(costEquipmentListArray) : "");
  //   input.append('mapPowerCostArray', mapPowerCostListArray.length > 0 ? JSON.stringify(mapPowerCostListArray) : "");
  //   input.append('consumablesArray', consumablesListArray.length > 0 ? JSON.stringify(consumablesListArray) : "");
  //   for (var i = 0; i < this.myFilesStep3.length; i++) {
  //     input.append(this.myFilesStep3[i].key, this.myFilesStep3[i].file);
  //   }
  //   return input;
  // }

  // submitStep3() {
  //   const self = this;
  //   this.submitted = true;
  //   const data = self.prepareStep3Data();
  //   this.loading = true;
  //   this._applyOnlineEuttcService
  //     .submitStep3Data(data)
  //     .pipe(first())
  //     .subscribe(
  //       response => {
  //         if (Number(response["statusCode"]) === statusCode.SUCCESS) {
  //           this.horizontalWizardStepperNext(this.format3);
  //         }
  //         else {
  //           this.loading = false;
  //           Swal.fire({
  //             icon: 'error',
  //             title: 'Error!',
  //             text: response["message"],
  //             customClass: {
  //               confirmButton: 'btn btn-error'
  //             }
  //           });
  //         }
  //       },
  //       error => {
  //         //this.error = error;
  //         this.isDisabled = false;
  //         this.loading = false;
  //         Swal.fire({
  //           icon: 'error',
  //           title: 'Error!',
  //           text: error,
  //           customClass: {
  //             confirmButton: 'btn btn-error'
  //           }
  //         });
  //       }
  //     );

  //   return false;
  // }

  // private prepareStep4Data(): any{
  //   let input: FormData = new FormData();
  //   var travelListArray = this.travelForm.value.travelArray.filter(a=> this.isvalidData(a.title));
  //   input.append('applyonlineId', (this.applicationID != undefined) ? this.applicationID : 0);
  //   input.append('travelArray', travelListArray.length > 0 ? JSON.stringify(travelListArray) : "");
  //   return input;
  // }

  // /**
  //  * On Submit
  //  */
  // onSubmit() {
  //   var result = confirm("Are you sure you want to finally submit this form?");
  //      if (result) {
  //   //Logic to delete the item

  //   const self = this;
  //   this.isDisabled = true;
  //   this.submitted = true;
  //   if (this.format4.invalid) {
  //     this.isDisabled = false;
  //     return false;
  //   }
  //   const data = self.prepareStep4Data();
  //   this.loading = true;
  //   this._applyOnlineEuttcService
  //     .submitStep4Data(data)
  //     .pipe(first())
  //     .subscribe(
  //       response => {
  //         if (Number(response["statusCode"]) === statusCode.SUCCESS) {
  //           this.isDisabled = false;
  //           this.submitted = false;
  //           Swal.fire({
  //             icon: 'success',
  //             title: 'Success!',
  //             text: 'Go to My Application and download the Application form. Then, upload the signed document to complete your Proposal submission process.',
  //             customClass: {
  //               confirmButton: 'btn btn-success'
  //             }
  //           });
  //           this._router.navigate(['/my-application']);
  //         }
  //         else {
  //           //this.error = response["message"];
  //           this.isDisabled = false;
  //           this.loading = false;
  //           Swal.fire({
  //             icon: 'error',
  //             title: 'Error!',
  //             text: response["message"],
  //             customClass: {
  //               confirmButton: 'btn btn-error'
  //             }
  //           });
  //         }
  //         this._router.navigate(['/my-application']);
  //       },
  //       error => {
  //         //this.error = error;
  //         this.isDisabled = false;
  //         this.loading = false;
  //         Swal.fire({
  //           icon: 'error',
  //           title: 'Error!',
  //           text: error,
  //           customClass: {
  //             confirmButton: 'btn btn-error'
  //           }
  //         });
  //       }
  //     );
  

  //   return false;
  // }
  // }

  // validateRow(id){
  //   const totalCostArray = <FormArray>this.totalCostForm.controls['costArray'];
  //   if(this.tempTotalCostArray != undefined && this.tempTotalCostArray.findIndex(t=> t.title == totalCostArray.value[id].title && !totalCostArray.value[id].isEdit) >= 0){
  //     this.hasDuplicateCostType = true;
  //     this.toastr.info('Already selected cost type is configured.', 'Info!', {
  //       positionClass: 'toast-bottom-right',
  //       toastClass: 'toast ngx-toastr',
  //       closeButton: true
  //     });
  //     return false;
  //   }
  //   this.hasDuplicateCostType = false;
  // }

  /** Function for add new row in TotalCost Table Step-1 **/
  // addRow() {
  //   const totalCostArray = <FormArray>this.totalCostForm.controls['costArray'];
  //   if(totalCostArray.length > 1){
  //     let lastRow = totalCostArray.value[totalCostArray.length - 1];
  //     if(this.tempTotalCostArray.findIndex(t=> t.title == lastRow.title && !lastRow.isEdit) >= 0){
  //       this.hasDuplicateCostType = true;
  //       this.toastr.info('Already selected cost type is configured.', 'Info!', {
  //         positionClass: 'toast-bottom-right',
  //         toastClass: 'toast ngx-toastr',
  //         closeButton: true
  //       });
  //       return false;
  //     }
  //   }
  //   this.hasDuplicateCostType = false;
  //   if (this.totalCostForm.status != "INVALID" && this.totalCostForm.controls['costArray']) {
  //     this.tempTotalCostArray = [];
  //     this.tempTotalCostArray = totalCostArray.value;
  //     totalCostArray.push(this.initCostRow(null, false));
  //     this.toastr.success('New row added sucessfully.', 'Success!', {
  //       positionClass: 'toast-bottom-right',
  //       toastClass: 'toast ngx-toastr',
  //       closeButton: true
  //     });
  //     return true;
  //   }
  //   else {
  //     this.toastr.info('please fillup the current row details.', 'Info!', {
  //       positionClass: 'toast-bottom-right',
  //       toastClass: 'toast ngx-toastr',
  //       closeButton: true
  //     });
  //   }
  //   return false;
  // }

  // /** Function for remove row from TotalCost Table Step-1 **/
  // deleteRow(index) {
  //   let newthis = this;
  //   this.hasDuplicateCostType = false;
  //   Swal.fire({
  //     title: 'Are you sure?',
  //     text: "You won't be remove this row!",
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonText: 'Yes, delete it!',
  //     customClass: {
  //       confirmButton: 'btn btn-primary',
  //       cancelButton: 'btn btn-danger ml-1'
  //     }
  //   }).then(function (result) {
  //     if (result.value) {
  //       const totalCostArray = <FormArray>newthis.totalCostForm.controls['costArray'];
  //       if (totalCostArray.length == 1) {
  //         newthis.toastr.error("Can't delete the row when there is only one row.", 'Info!', {
  //           positionClass: 'toast-bottom-right',
  //           toastClass: 'toast ngx-toastr',
  //           closeButton: true
  //         });
  //         return false;
  //       } else {
  //         if(newthis.tempTotalCostArray != undefined && newthis.tempTotalCostArray.findIndex(t=> t.title == totalCostArray.value[index].title) >= 0){
  //           newthis.tempTotalCostArray.splice(index, 1);
  //         }
  //         totalCostArray.removeAt(index);
  //         newthis.setAllFieldTotalCost(0);
  //         newthis.toastr.info("Row deleted successfully.", 'Info!', {
  //           positionClass: 'toast-bottom-right',
  //           toastClass: 'toast ngx-toastr',
  //           closeButton: true
  //         });
  //         return true;
  //       }
  //     } else if (result.dismiss === Swal.DismissReason.cancel) {
  //       Swal.fire({
  //         title: 'Cancelled',
  //         text: 'Your imaginary file is safe :)',
  //         icon: 'error',
  //         customClass: {
  //           confirmButton: 'btn btn-success'
  //         }
  //       });
  //     }
  //   });                                                                                          
  // }

  /** Function for add new row in TotalCost Table Step-1 **/
  // addProjectPlanRow() {
  //   const projectPlanArray = <FormArray>this.projectPlanForm.controls['projectPlanArray'];
  //   if (this.projectPlanForm.status != "INVALID") {
  //     projectPlanArray.push(this.initProjectPlanRow(null, false));
  //     this.toastr.success('New row added sucessfully.', 'Success!', {
  //       positionClass: 'toast-bottom-right',
  //       toastClass: 'toast ngx-toastr',
  //       closeButton: true
  //     });
  //     //this.setChartData();
  //     return true;
  //   }
  //   else {
  //     this.toastr.info('please fillup the current row details.', 'Info!', {
  //       positionClass: 'toast-bottom-right',
  //       toastClass: 'toast ngx-toastr',
  //       closeButton: true
  //     });
  //   }
  //   return false;
  // }

  /** Function for remove row from TotalCost Table Step-1 **/
  // deleteProjectPlanRow(index) {
  //   let newthis = this;
  //   Swal.fire({
  //     title: 'Are you sure?',
  //     text: "You won't be remove this row!",
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonText: 'Yes, delete it!',
  //     customClass: {
  //       confirmButton: 'btn btn-primary',
  //       cancelButton: 'btn btn-danger ml-1'
  //     }
  //   }).then(function (result) {
  //     if (result.value) {
  //       const projectPlanArray = <FormArray>newthis.projectPlanForm.controls['projectPlanArray'];
  //       if (projectPlanArray.length == 1) {
  //         newthis.toastr.error("Can't delete the row when there is only one row.", 'Info!', {
  //           positionClass: 'toast-bottom-right',
  //           toastClass: 'toast ngx-toastr',
  //           closeButton: true
  //         });
  //         return false;
  //       } else {
  //         projectPlanArray.removeAt(index);
  //         newthis.toastr.info("Row deleted successfully.", 'Info!', {
  //           positionClass: 'toast-bottom-right',
  //           toastClass: 'toast ngx-toastr',
  //           closeButton: true
  //         });
  //         //this.setChartData();
  //         return true;
  //       }
  //     } else if (result.dismiss === Swal.DismissReason.cancel) {
  //       Swal.fire({
  //         title: 'Cancelled',
  //         text: 'Your imaginary file is safe :)',
  //         icon: 'error',
  //         customClass: {
  //           confirmButton: 'btn btn-success'
  //         }
  //       });
  //     }
  //   });
  // }

  // /**
  //  * function for set end Min data based on start date. 
  //  ***/
  // setEndMinDate(index) {
  //   const projectPlanArray = <FormArray>this.projectPlanForm.controls['projectPlanArray'];	
  //   if (projectPlanArray.controls[index].value.startDate != undefined && projectPlanArray.controls[index].value.startDate != null) {
  //     this.endminDate = (projectPlanArray.controls[index].value.startDate != undefined && projectPlanArray.controls[index].value.startDate != null)
  //       ? projectPlanArray.controls[index].value.startDate : this.calendar.getToday();
  //   } else {
  //     this.endminDate = (this.minDate != undefined && this.minDate != null) ? this.minDate : this.calendar.getToday();
  //   }
  // }

  // /**
  //  * function for set start Min and reset end date if first selected. 
  //  ***/
  // setStartMinDate(index) {
  //   const projectPlanArray = <FormArray>this.projectPlanForm.controls['projectPlanArray'];
  //   if(projectPlanArray.controls[0].value.startDate != null && projectPlanArray.controls[0].value.startDate != '' && index == 0){
  //     Swal.fire({
  //       title: 'Are you sure?',
  //       text: "You won't to change this record!",
  //       icon: 'warning',
  //       showCancelButton: true,
  //       confirmButtonText: 'Yes, change it!',
  //       customClass: {
  //         confirmButton: 'btn btn-primary',
  //         cancelButton: 'btn btn-danger ml-1'
  //       }
  //     }).then(function (result) {
  //       if (result.value) {
  //         if(projectPlanArray.controls.length >= 0){
  //           projectPlanArray.controls.forEach((element, i) => {
  //             projectPlanArray.controls[i]["controls"].startDate.setValue("");
  //             projectPlanArray.controls[i]["controls"].endDate.setValue("");
  //           });
  //         }
  //       } else if (result.dismiss === Swal.DismissReason.cancel) {
  //         Swal.fire({
  //           title: 'Cancelled',
  //           text: 'Your data is safe :)',
  //           icon: 'error',
  //           customClass: {
  //             confirmButton: 'btn btn-success'
  //           }
  //         });
  //       }
  //     });
  //   }
  //   // if (projectPlanArray.controls[index].value.endDate != undefined && projectPlanArray.controls[index].value.endDate != null) {
  //   // 	//Reset End Date field
  //   // 	projectPlanArray.controls[index]["controls"].endDate.setValue("");
  //   // }
  // }
  
  // setMinDate(index) {
  //   const projectPlanArray = <FormArray>this.projectPlanForm.controls['projectPlanArray'];
  //   if (projectPlanArray.controls[index].value.startDate != undefined && projectPlanArray.controls[index].value.startDate != null) {
  //     this.endminDate = (projectPlanArray.controls[index].value.startDate != undefined && projectPlanArray.controls[index].value.startDate != null)
  //       ? projectPlanArray.controls[index].value.startDate : this.calendar.getToday();
  //   } else{
  //     this.endminDate = (this.minDate != undefined && this.minDate != null) ? this.minDate : this.calendar.getToday();
  //   }
  //   return this.endminDate;
  // }
  // setNextMinDate(index){
  //   const projectPlanArray = <FormArray>this.projectPlanForm.controls['projectPlanArray'];
  //   this.nextMinDate = projectPlanArray.controls[index-1].value.startDate;
    
  //   return this.nextMinDate;
  // }
  // setMaxDate(index){
  //   const projectPlanArray = <FormArray>this.projectPlanForm.controls['projectPlanArray'];
  //   const duration = this.format1.controls.Duration.value;
  //   if(projectPlanArray.controls[index].value.startDate != undefined && projectPlanArray.controls[index].value.startDate != null){
  //     let year = projectPlanArray.controls[index].value.startDate.year ;
  //     let month = projectPlanArray.controls[index].value.startDate.month + 10;
  //     let days = projectPlanArray.controls[index].value.startDate.day;
  //     let maxDate = projectPlanArray.controls[0].value.startDate;
  //     const newFormattedDate = new Date(Date.UTC(maxDate.year, maxDate.month - 1, maxDate.day));
  //     const monthAddedDate = new Date(newFormattedDate.setMonth(newFormattedDate.getMonth() + parseInt(duration)));
  //     this.finalmaxdate = {
  //       year : monthAddedDate.getFullYear(),
  //       month : monthAddedDate.getUTCMonth()+1,
  //       day : monthAddedDate.getDate()
  //     }
  //   }
  //   return this.finalmaxdate;
  // }
  
  /** Function for add new row in Equipment Table Step-2 **/
  // addEquipmentRow() {
  //   const equipmentRowArray = <FormArray>this.equipmentForm.controls['equipmentArray'];
  //   if (this.equipmentForm.status != "INVALID") {
  //     equipmentRowArray.push(this.initEquipmentRow(null, false));
  //     this.toastr.success('New row added sucessfully.', 'Success!', {
  //       positionClass: 'toast-bottom-right',
  //       toastClass: 'toast ngx-toastr',
  //       closeButton: true
  //     });
  //     return true;
  //   }
  //   else {
  //     this.toastr.info('please fillup the current row details.', 'Info!', {
  //       positionClass: 'toast-bottom-right',
  //       toastClass: 'toast ngx-toastr',
  //       closeButton: true
  //     });
  //   }
  //   return false;
  // }

  // /** Function for remove row from Equipment Table Step-2 **/
  // deleteEquipmentRow(index) {
  //   let newthis = this;
  //   Swal.fire({
  //     title: 'Are you sure?',
  //     text: "You won't be remove this row!",
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonText: 'Yes, delete it!',
  //     customClass: {
  //       confirmButton: 'btn btn-primary',
  //       cancelButton: 'btn btn-danger ml-1'
  //     }
  //   }).then(function (result) {
  //     if (result.value) {
  //       const equipmentRowArray = <FormArray>newthis.equipmentForm.controls['equipmentArray'];
  //       if (equipmentRowArray.length == 1) {
  //         newthis.toastr.error("Can't delete the row when there is only one row.", 'Info!', {
  //           positionClass: 'toast-bottom-right',
  //           toastClass: 'toast ngx-toastr',
  //           closeButton: true
  //         });
  //         return false;
  //       } else {
  //         equipmentRowArray.removeAt(index);
  //         newthis.toastr.info("Row deleted successfully.", 'Info!', {
  //           positionClass: 'toast-bottom-right',
  //           toastClass: 'toast ngx-toastr',
  //           closeButton: true
  //         });
  //         return true;
  //       }
  //     } else if (result.dismiss === Swal.DismissReason.cancel) {
  //       Swal.fire({
  //         title: 'Cancelled',
  //         text: 'Your imaginary file is safe :)',
  //         icon: 'error',
  //         customClass: {
  //           confirmButton: 'btn btn-success'
  //         }
  //       });
  //     }
  //   });
  // }

  // /** Function for add now row in Manpower Table Step-3 **/
  // addManpowerRow() {
  //   const manpowerRowArray = <FormArray>this.manpowerForm.controls['manpowerArray'];
  //   if (this.manpowerForm.status != "INVALID") {
  //     manpowerRowArray.push(this.initManpowerRow(null, false));
  //     this.toastr.success('New row added sucessfully.', 'Success!', {
  //       positionClass: 'toast-bottom-right',
  //       toastClass: 'toast ngx-toastr',
  //       closeButton: true
  //     });
  //     return true;
  //   }
  //   else {
  //     this.toastr.info('please fillup the current row details.', 'Info!', {
  //       positionClass: 'toast-bottom-right',
  //       toastClass: 'toast ngx-toastr',
  //       closeButton: true
  //     });
  //   }
  //   return false;
  // }

  // /** Function for remove row from Manpower Table Step-3 **/
  // deleteManpowerRow(index) {
  //   let newthis = this;
  //   Swal.fire({
  //     title: 'Are you sure?',
  //     text: "You won't be remove this row!",
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonText: 'Yes, delete it!',
  //     customClass: {
  //       confirmButton: 'btn btn-primary',
  //       cancelButton: 'btn btn-danger ml-1'
  //     }
  //   }).then(function (result) {
  //     if (result.value) {
  //       const manpowerRowArray = <FormArray>newthis.manpowerForm.controls['manpowerArray'];
  //       if (manpowerRowArray.length == 1) {
  //         newthis.toastr.error("Can't delete the row when there is only one row.", 'Info!', {
  //           positionClass: 'toast-bottom-right',
  //           toastClass: 'toast ngx-toastr',
  //           closeButton: true
  //         });
  //         return false;
  //       } else {
  //         manpowerRowArray.removeAt(index);
  //         newthis.toastr.info("Row deleted successfully.", 'Info!', {
  //           positionClass: 'toast-bottom-right',
  //           toastClass: 'toast ngx-toastr',
  //           closeButton: true
  //         });
  //         return true;
  //       }
  //     } else if (result.dismiss === Swal.DismissReason.cancel) {
  //       Swal.fire({
  //         title: 'Cancelled',
  //         text: 'Your imaginary file is safe :)',
  //         icon: 'error',
  //         customClass: {
  //           confirmButton: 'btn btn-success'
  //         }
  //       });
  //     }
  //   });
  // }

  // setUnitName(index: any){
  //   if(index >= 0){
  //     const data = <FormArray>this.consumablesForm.controls['consumablesArray']["controls"][index];
  //     if(data != null){
  //       let unitId = data.controls["unit"].value;
  //       let unitname = this.unitsType.find(u=>u.unitsTypeID == unitId).unitsTypeName;
  //       data.controls["unitName"].setValue(unitname);
  //     }
  //   }
  // }

  // /** Function for add new row in Consumable Table Step-3 **/
  // addConsumablesRow() {
  //   const consumablesRowArray = <FormArray>this.consumablesForm.controls['consumablesArray'];
  //   if (this.consumablesForm.status != "INVALID") {
  //     consumablesRowArray.push(this.initConsumablesRow(null, false));
  //     this.toastr.success('New row added sucessfully.', 'Success!', {
  //       positionClass: 'toast-bottom-right',
  //       toastClass: 'toast ngx-toastr',
  //       closeButton: true
  //     });
  //     return true;
  //   }
  //   else {
  //     this.toastr.info('please fillup the current row details.', 'Info!', {
  //       positionClass: 'toast-bottom-right',
  //       toastClass: 'toast ngx-toastr',
  //       closeButton: true
  //     });
  //   }
  //   return false;
  // }

  // /** Function for remove row from Consumable Table Step-3 **/
  // deleteConsumablesRow(index) {
  //   let newthis = this;
  //   Swal.fire({
  //     title: 'Are you sure?',
  //     text: "You won't be remove this row!",
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonText: 'Yes, delete it!',
  //     customClass: {
  //       confirmButton: 'btn btn-primary',
  //       cancelButton: 'btn btn-danger ml-1'
  //     }
  //   }).then(function (result) {
  //     if (result.value) {
  //       const consumablesRowArray = <FormArray>newthis.consumablesForm.controls['consumablesArray'];
  //       if (consumablesRowArray.length == 1) {
  //         newthis.toastr.error("Can't delete the row when there is only one row.", 'Info!', {
  //           positionClass: 'toast-bottom-right',
  //           toastClass: 'toast ngx-toastr',
  //           closeButton: true
  //         });
  //         return false;
  //       } else {
  //         consumablesRowArray.removeAt(index);
  //         newthis.toastr.info("Row deleted successfully.", 'Info!', {
  //           positionClass: 'toast-bottom-right',
  //           toastClass: 'toast ngx-toastr',
  //           closeButton: true
  //         });
  //         return true;
  //       }
  //     } else if (result.dismiss === Swal.DismissReason.cancel) {
  //       Swal.fire({
  //         title: 'Cancelled',
  //         text: 'Your imaginary file is safe :)',
  //         icon: 'error',
  //         customClass: {
  //           confirmButton: 'btn btn-success'
  //         }
  //       });
  //     }
  //   });
  // }

  // /** Function for add new row in Travel Table Step-4 **/
  // addTravelRow() {
  //   const travelRowArray = <FormArray>this.travelForm.controls['travelArray'];
  //   if (this.travelForm.status != "INVALID") {
  //     travelRowArray.push(this.initTravelRow(null, false));
  //     this.toastr.success('New row added sucessfully.', 'Success!', {
  //       positionClass: 'toast-bottom-right',
  //       toastClass: 'toast ngx-toastr',
  //       closeButton: true
  //     });
  //     return true;
  //   }
  //   else {
  //     this.toastr.info('please fillup the current row details.', 'Info!', {
  //       positionClass: 'toast-bottom-right',
  //       toastClass: 'toast ngx-toastr',
  //       closeButton: true
  //     });
  //   }
  //   return false;
  // }

  // /** Function for remove row from Travel Table Step-4 **/
  // deleteTravelRow(index) {
  //   let newthis = this;
  //   Swal.fire({
  //     title: 'Are you sure?',
  //     text: "You won't be remove this row!",
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonText: 'Yes, delete it!',
  //     customClass: {
  //       confirmButton: 'btn btn-primary',
  //       cancelButton: 'btn btn-danger ml-1'
  //     }
  //   }).then(function (result) {
  //     if (result.value) {
  //       const travelRowArray = <FormArray>newthis.travelForm.controls['travelArray'];
  //       if (travelRowArray.length == 1) {
  //         newthis.toastr.error("Can't delete the row when there is only one row.", 'Info!', {
  //           positionClass: 'toast-bottom-right',
  //           toastClass: 'toast ngx-toastr',
  //           closeButton: true
  //         });
  //         return false;
  //       } else {
  //         travelRowArray.removeAt(index);
  //         newthis.toastr.info("Row deleted successfully.", 'Info!', {
  //           positionClass: 'toast-bottom-right',
  //           toastClass: 'toast ngx-toastr',
  //           closeButton: true
  //         });
  //         return true;
  //       }
  //     } else if (result.dismiss === Swal.DismissReason.cancel) {
  //       Swal.fire({
  //         title: 'Cancelled',
  //         text: 'Your imaginary file is safe :)',
  //         icon: 'error',
  //         customClass: {
  //           confirmButton: 'btn btn-success'
  //         }
  //       });
  //     }
  //   });
  // }

  // leadPartnerOptionsSelected(value) {
  //   //alert(value);
  //   //let numbers : Array<number>; 
  //       //numbers = value;
  //   this.displayLeadPartnerField = false;
  //   if (value==7) {
  //     this.displayLeadPartnerField = true;
  //   }
  //   else {
  //     this.format1.controls.LeadPartner.setValue("");
  //     this.displayLeadPartnerField = false;
  //   }	
  // }

  // CoPrincipalOptionsSelected(value) {
  //   //alert(value);
  //   //let numbers : Array<number>; 
  //       //numbers = value;
  //   this.displayCoPrincipalField = false;
  //   if (value==2) {
  //     this.displayCoPrincipalField = true;
  //   }
  //   else {
  //     this.displayCoPrincipalField = false;
  //   }	
  // }

  

  // onareaOfResearchOptionsSelected(value) {
  //   //alert(value);
  //   let numbers : Array<number>; 
  //       numbers = value;
  //   if (numbers.includes(6)) {
  //     this.displayOtherField = true;
  //   }
  //   else {
  //     this.format1.controls.OtherAreaofResearch.setValue("");
  //     this.displayOtherField = false;
  //   }	
  // }

  // onOptionsSelected(value) {
  //   let data = value;
  //   if (data.replace(' ', '') == 'Non-GovernmentalOrganization') {
  //     this.displayField = true;
  //   }
  //   else {
  //     this.format1.controls.DarpanPortlRegisterID.setValue("");
  //     this.displayField = false;
  //   }
  // }

  // numFormat(number){
  //       var outputformat = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2,minimumFractionDigits: 2 }).format(number);
  //       return outputformat;
  //   }

  // setAllFieldTotal(index: number) {

  //   let total = 0;
  //   if(this.noOfYeararray.length > 0){
  //     this.noOfYeararray.forEach(element => {
  //       var formControlname = element.label;
  //       let value = isNaN(parseFloat(this.proposedCostForm.controls.proposedCostArray["controls"][index].value[formControlname])) ? 0 :
  //             this.proposedCostForm.controls.proposedCostArray["controls"][index].value[formControlname].toString().includes(",") ? 
  //             parseFloat(this.proposedCostForm.controls.proposedCostArray["controls"][index].value[formControlname].replaceAll(",","")) :
  //             parseFloat(this.proposedCostForm.controls.proposedCostArray["controls"][index].value[formControlname]);
  //       total = total + value;
  //     });
  //   }
  //   this.proposedCostForm.controls.proposedCostArray["controls"][index].controls.totalCost.setValue(this.numFormat(total));
  //   total = 0;

  //   var allTotal = 0.00;
  //   if(this.noOfYeararray.length > 0){
  //     this.noOfYeararray.forEach(ele => {
  //       var formControlname = ele.label;
  //       var colTotal = 0;
  //       this.proposedCostForm.controls.proposedCostArray.value.forEach(element => {
  //         let value = isNaN(parseFloat(element[formControlname])) ? 0 :
  //         parseFloat(element[formControlname].toString().includes(",") ? parseFloat(element[formControlname].replaceAll(",","")) :  element[formControlname]);
  //         colTotal = colTotal + value;
  //       });
  //       ele.proposedCostTotal = this.numFormat(colTotal.toFixed(2));
  //     });
  //   }

  //   this.proposedCostForm.controls.proposedCostArray.value.forEach(element => {
  //     allTotal = allTotal + parseFloat(element.totalCost.toString().includes(",") ? element.totalCost.replaceAll(",","") : element.totalCost);
  //   });
  //   this.format2.controls.allTotalCost.setValue(this.numFormat(allTotal.toFixed(2)));
  // }

  // setManPowerYearTotal(index: number) {
    
  //   let total = 0;
  //   if(this.noOfYeararray.length > 0){
  //     this.noOfYeararray.forEach(element => {
  //       var formControlname = element.label;
  //       let value = isNaN(parseFloat(this.manpowerForm.controls.manpowerArray["controls"][index].value[formControlname])) ? 0 :
  //             this.manpowerForm.controls.manpowerArray["controls"][index].value[formControlname].toString().includes(",") ? 
  //             parseFloat(this.manpowerForm.controls.manpowerArray["controls"][index].value[formControlname].replaceAll(",","")) :
  //             parseFloat(this.manpowerForm.controls.manpowerArray["controls"][index].value[formControlname]);
  //       total = total + value;
  //     });
  //   }
  //   this.manpowerForm.controls.manpowerArray["controls"][index].controls.total.setValue(this.numFormat(total));
  // }

  // setConsumablesFormFieldTotal() {
  //   if(this.noOfYeararray.length > 0){
  //     this.noOfYeararray.forEach(ele => {
  //       var formControlname = ele.label;
  //       var colTotal = 0;
  //       this.consumablesForm.controls.consumablesArray.value.forEach(element => {
  //         let value = isNaN(parseFloat(element[formControlname])) ? 0 :
  //         parseFloat(element[formControlname].toString().includes(",") ? parseFloat(element[formControlname].replaceAll(",","")) :  element[formControlname]);
  //         colTotal = colTotal + value;
  //       });
  //       ele.costofConsumableTotal = this.numFormat(colTotal);
  //     });
  //   }
  // }

  // setTravelCostTotal(index: number) {
  //   let total = 0;
  //   if(this.noOfYeararray.length > 0){
  //     this.noOfYeararray.forEach(element => {
  //       var formControlname = element.label;
  //       let value = isNaN(parseFloat(this.travelForm.controls.travelArray["controls"][index].value[formControlname])) ? 0 :
  //             this.travelForm.controls.travelArray["controls"][index].value[formControlname].toString().includes(",") ? 
  //             parseFloat(this.travelForm.controls.travelArray["controls"][index].value[formControlname].replaceAll(",","")) :
  //             parseFloat(this.travelForm.controls.travelArray["controls"][index].value[formControlname]);
  //       total = total + value;
  //     });
  //   }
  //   this.travelForm.controls.travelArray["controls"][index].controls.total.setValue(this.numFormat(total));
  // }

  // showFiles(documentList: any) {
  //   let files = '';
  //   for (let i = 0; i < documentList.length; i++) {
  //     files += documentList[i].file.name;

  //     if (!(documentList.length - 1 === i)) {
  //       files += ',';
  //     }
  //   }
  //   return files;
  // }

  
  // /** Function for add new row in TotalCost Table Step-1 **/
  // addContactRow() {
  //   const contactDetailArray = <FormArray>this.contactDetailsForm.controls['contactDetailsArray'];
  //   if (this.contactDetailsForm.status != "INVALID") {
  //     contactDetailArray.push(this.initContactDetailRow(null, false));
  //     this.toastr.success('New row added sucessfully.', 'Success!', {
  //       positionClass: 'toast-bottom-right',
  //       toastClass: 'toast ngx-toastr',
  //       closeButton: true
  //     });
  //     return true;
  //   }
  //   else {
  //     this.toastr.info('please fillup the current row details.', 'Info!', {
  //       positionClass: 'toast-bottom-right',
  //       toastClass: 'toast ngx-toastr',
  //       closeButton: true
  //     });
  //   }
  //   return false;
  // }

  // initContactDetailRow(element, isEdit): FormGroup {
  //   if(isEdit){
  //     return this._formBuilder.group({
  //       id: [element.id],
  //       CoPrincipalInvestigator: [element.CoPrincipalInvestigator, [Validators.required,]],
  //       CoPrincipalInvestigatorContactNo: [element.CoPrincipalInvestigatorContactNo, [Validators.required]],
  //     });
  //   }
  //   else{
  //     return this._formBuilder.group({
  //       id:[0],
  //       CoPrincipalInvestigator: ['', [Validators.required,]],
  //       CoPrincipalInvestigatorContactNo: ['', [Validators.required]],
  //     });
  //   }
  // }

  // deleteContactDetailRow(index) {
  //   let newthis = this;
  //   Swal.fire({
  //     title: 'Are you sure?',
  //     text: "You won't be remove this row!",
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonText: 'Yes, delete it!',
  //     customClass: {
  //       confirmButton: 'btn btn-primary',
  //       cancelButton: 'btn btn-danger ml-1'
  //     }
  //   }).then(function (result) {
  //     if (result.value) {
  //       const contactDetailsArray = <FormArray>newthis.contactDetailsForm.controls['contactDetailsArray'];
  //       if (contactDetailsArray.length == 1) {
  //         newthis.toastr.error("Can't delete the row when there is only one row.", 'Info!', {
  //           positionClass: 'toast-bottom-right',
  //           toastClass: 'toast ngx-toastr',
  //           closeButton: true
  //         });
  //         return false;
  //       } else {
  //         contactDetailsArray.removeAt(index);
  //         newthis.toastr.info("Row deleted successfully.", 'Info!', {
  //           positionClass: 'toast-bottom-right',
  //           toastClass: 'toast ngx-toastr',
  //           closeButton: true
  //         });
  //         return true;
  //       }
  //     } else if (result.dismiss === Swal.DismissReason.cancel) {
  //       Swal.fire({
  //         title: 'Cancelled',
  //         text: 'Your imaginary file is safe :)',
  //         icon: 'error',
  //         customClass: {
  //           confirmButton: 'btn btn-success'
  //         }
  //       });
  //     }
  //   });
  // }

  // setAllFieldTotalCost(index: number,isEditCost=0) {
  //   let total = 0;
  //   let costValue = this.totalCostForm.controls.costArray["controls"][index].value.value;
  //   if(isEditCost == 1){
  //     total = costValue;
  //   }else{
  //     total = (
  //       (isNaN(parseFloat(costValue.replaceAll(",",""))) ? 0 : parseFloat(costValue.replaceAll(",",""))) 
  //       );
  //   }
    
  //   //this.totalCostForm.controls.costArray["controls"][index].controls.totalCostValue.setValue(this.numFormat(total.toFixed(2)));
  //   var totalCost = 0.00;
    
  //   if(isEditCost == 1){
  //     this.totalCostForm.controls.costArray.value.forEach(element => {
  //       totalCost = totalCost + (isNaN(parseFloat(element.value)) ? 0.00 : parseFloat(element.value));
  //     });
  //   }else{
  //     this.totalCostForm.controls.costArray.value.forEach(element => {
  //       totalCost = totalCost + (isNaN(parseFloat(element.value)) ? 0.00 : parseFloat(element.value.replaceAll(",","")));
  //     });
  //   }
    
  //   this.format1.controls.totalCostValue.setValue(this.numFormat(totalCost.toFixed(2)));
    
  // }
  // isSelected: boolean
  // loadSubjectTypeData(isEdit:boolean) {
  //   this._commonService.getSubjectArea(ParentParameters.ID).subscribe((result: any) => {
  //     this.subjectAreaType = [];
  //     if (result.statusCode == 200) {
  //       result["data"]["response"].forEach(element => {
  //         this.isSelected = this.isCheckedTrue(element.paraId,isEdit);
  //         this.subjectAreaType.push({
  //           item_text: element.paraDescription,
  //           item_id: element.paraId,
  //           isSelected: this.isSelected
  //         });
  //         if(this.isSelected){
  //           if(this.selectedIDs.findIndex(s=>s == element.paraId) == -1){
  //             this.selectedIDs.push(element.paraId.toString());
  //           }
  //         }
  //       });
  //     }
  //   });
  // }


  // loadSubjectTypeData(isEdit:boolean) {
  // 	this._commonService.getParameterSettings(ParentParameters.SUBJECTAREA).subscribe((result: any) => {
  // 		this.subjectAreaType = [];
  // 		if (result.statusCode == 200) {
  // 			result["data"]["response"].forEach(element => {
  // 				this.isSelected = this.isCheckedTrue(element.paraId,isEdit);
  // 				this.subjectAreaType.push({
  // 					item_text: element.paraDescription,
  // 					item_id: element.paraId,
  // 					isSelected: this.isSelected
  // 				});
  // 				if(this.isSelected){
  // 					if(this.selectedIDs.findIndex(s=>s == element.paraId) == -1){
  // 						this.selectedIDs.push(element.paraId.toString());
  // 					}
  // 				}
  // 			});
  // 		}
  // 	});
  // }

  // isCheckedTrue(paraId:number,isEdit:boolean){
  //   if(isEdit == true){
  //     this.subjectAreaId = this.getSubjectAreaId;
  //   }else{
  //     //this.subjectAreaId = this.currentUser.subjectArea.split(',');
  //     this.subjectAreaId = [];
  //   }
  //   return (this.subjectAreaId.findIndex(s=>s == paraId) != -1) ? true : false;
  // }
  // selectedIDs: any = [];
  // onCheckboxChange(e){
    
  //   if (e.target.checked) {
  //     this.selectedIDs.push(e.target.value);
  //   } else {
  //     const index = this.selectedIDs.findIndex(x=> x == e.target.value);
  //     if(index >= 0){
  //       this.selectedIDs.splice(index, 1);
  //     }
  //   }
  //   this.format1.controls.SubjectArea.setValue(this.selectedIDs);
    
  // }

  

  // getstateDetails() {
    
  //   this._commonService.getAllStateData().subscribe((result: any) => {
  //     this.stateArray = [];
  //     if (result.statusCode == 200) {
  //       result["data"]["response"].forEach(element => {
  //         this.stateArray.push({
  //           stateName: element.name,
  //           stateID: element.id
  //         });
  //       });
  //     }
  //   });
  // }
  // getCityDistrictDetails(event: any) {
  //   var stateId = event.stateID;
  //   this._commonService.getDistrictData(stateId).subscribe((result: any) => {
  //     this.cityArray = [];
  //     if (result.statusCode == 200) {
  //       result["data"]["response"].forEach(element => {
  //         this.cityArray.push({
  //           districtName: element.districtTitle,
  //           districtID: element.id
  //         });
  //       });
  //     }
  //   });
  // }
}